// // CreateSale.jsx
// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import SaleService from '../../services/SaleService';
// import RouteService from '../../services/routeService';
// import StockService from '../../services/stockService';
// import ShiftService from '../../services/shiftService';
// import ToastService from '../../services/toastService';
// import AuthService from '../../services/authService';
// import './CreateSale.css';

// import { usePrinter } from '../../context/PrinterContext';
// import EscPosEncoder from 'esc-pos-encoder';

// const CreateSale = () => {
//   const navigate = useNavigate();
//     const { characteristic } = usePrinter();
//   // State variables
//   const [loading, setLoading] = useState({
//     customers: true,
//     routes: true,
//     categories: true,
//     products: true
//   });
//   const [customers, setCustomers] = useState([]);
//   const [routes, setRoutes] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [saleData, setSaleData] = useState({
//     customerId: '',
//     routeId: '',
//     inventoryId: '',
//     products: [],
//     paymentMethods: [],
//     productreturnData: null
//   });
//   const [currentProduct, setCurrentProduct] = useState({
//     categoryId: '',
//     productId: '',
//     quantity: 1,
//     pricePerUnit: 0,
//     availableStock: 0,
//     productName: '',
//     unit: ''
//   });
//   const [invoiceNumber, setInvoiceNumber] = useState('');
//   const [outstandingBalance, setOutstandingBalance] = useState(0);
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [showCollectionModal, setShowCollectionModal] = useState(false);
//   const [tempPayments, setTempPayments] = useState([]);
//   const [tempCollections, setTempCollections] = useState([]);
//   const [paymentInput, setPaymentInput] = useState({
//     method: 'CASH',
//     amount: '',
//     chequeNumber: '',
//     bank: '',
//     reference: ''
//   });
//   const [collectionInput, setCollectionInput] = useState({
//     method: 'CASH',
//     amount: '',
//     chequeNumber: '',
//     bank: '',
//     reference: ''
//   });
//   const [returnAmount, setReturnAmount] = useState('');
//   const [cartItems, setCartItems] = useState([]);
//   const [processingSale, setProcessingSale] = useState(false);
//   const [pollingInterval, setPollingInterval] = useState(null);
//   const [optimisticStockUpdates, setOptimisticStockUpdates] = useState({});

//   // Initialize data
//   useEffect(() => {
//     if (!AuthService.isAuthenticated()) {
//       navigate('/login');
//       return;
//     }
//     initializeSale();
    
//     // Start polling for stock updates every 30 seconds
//     const interval = setInterval(() => {
//       if (saleData.inventoryId) {
//         refreshStockData();
//       }
//     }, 30000);
    
//     setPollingInterval(interval);
    
//     // Cleanup on unmount
//     return () => {
//       if (interval) clearInterval(interval);
//       if (pollingInterval) clearInterval(pollingInterval);
//     };
//   }, [navigate]);

//   const initializeSale = async () => {
//     try {
//       setLoading({ customers: true, routes: true, categories: true, products: true });
      
//       // Get current shift info
//       ShiftService.initializeShift();
//       const activeRouteId = ShiftService.getActiveRouteId();
//       const activeInventoryId = ShiftService.getActiveInventoryId();
      
//       if (!activeRouteId || !activeInventoryId) {
//         ToastService.error('Please start a shift first');
//         navigate('/shift');
//         return;
//       }

//       // Set initial sale data
//       setSaleData(prev => ({
//         ...prev,
//         routeId: activeRouteId,
//         inventoryId: activeInventoryId
//       }));

//       // Load data sequentially
//       await loadInvoiceNumber();
//       await loadRoutes();
//       await loadCustomers(activeRouteId);
//       await loadStockAndProducts(activeInventoryId);
      
//     } catch (error) {
//       ToastService.error('Failed to initialize sale: ' + (error.message || 'Network error'));
//       console.error('Initialize sale error:', error);
//     } finally {
//       setLoading({ customers: false, routes: false, categories: false, products: false });
//     }
//   };

//   const loadCustomers = async (routeId) => {
//     try {
//       const customersData = await SaleService.getCustomersByRoute(routeId);
//       const customersArray = Array.isArray(customersData) ? customersData : 
//                            customersData.data ? customersData.data : [];
//       setCustomers(customersArray);
      
//       // Pre-select first customer if available
//       if (customersArray.length > 0) {
//         const firstCustomer = customersArray[0];
//         setSaleData(prev => ({ ...prev, customerId: firstCustomer.id }));
//         await loadCustomerCreditBalance(firstCustomer.id, routeId);
//       }
//     } catch (error) {
//       ToastService.error('Failed to load customers');
//       console.error('Load customers error:', error);
//     }
//   };

//   const loadRoutes = async () => {
//     try {
//       const routesData = await SaleService.getAvailableRoutes();
//       const routesArray = Array.isArray(routesData) ? routesData : 
//                          routesData.data ? routesData.data : [];
//       setRoutes(routesArray);
//     } catch (error) {
//       ToastService.error('Failed to load routes');
//       console.error('Load routes error:', error);
//     }
//   };

//   const loadInvoiceNumber = async () => {
//     try {
//       const invoiceData = await SaleService.getInvoiceNumber();
//       setInvoiceNumber(invoiceData.invoiceNumber || invoiceData.data?.invoiceNumber || `INV-${Date.now()}`);
//     } catch (error) {
//       setInvoiceNumber(`INV-${Date.now()}`);
//       console.error('Load invoice error:', error);
//     }
//   };

//   const loadStockAndProducts = async (inventoryId) => {
//     try {
//       // Load stock data which includes product information
//       const stockResponse = await StockService.getStockByInventory(inventoryId);
//       let stockList = [];
      
//       if (Array.isArray(stockResponse)) {
//         stockList = stockResponse;
//       } else if (stockResponse.data && Array.isArray(stockResponse.data)) {
//         stockList = stockResponse.data;
//       }
      
//       // Process products and categories
//       const categoryMap = new Map();
//       const productsList = [];
      
//       stockList.forEach(stockItem => {
//         if (stockItem && stockItem.category) {
//           const category = stockItem.category;
//           const product = stockItem;
          
//           // Add category to map
//           if (!categoryMap.has(category.id)) {
//             categoryMap.set(category.id, {
//               id: category.id,
//               name: category.name
//             });
//           }
          
//           // Apply optimistic updates if any
//           const optimisticUpdate = optimisticStockUpdates[product.id];
//           const adjustedStock = optimisticUpdate ? 
//             product.qty - optimisticUpdate : 
//             product.qty;
          
//           // Add to products list
//           productsList.push({
//             id: product.id,
//             name: product.productName,
//             categoryId: category.id,
//             categoryName: category.name,
//             price: product.pricePerUnit || 0,
//             availableStock: Math.max(0, adjustedStock),
//             isActive: product.isActive !== false,
//             inventoryId: product.inventory?.id
//           });
//         }
//       });
      
//       // Filter only active products
//       const activeProducts = productsList.filter(product => product.isActive);
      
//       setCategories(Array.from(categoryMap.values()));
//       setProducts(activeProducts);
//       setFilteredProducts(activeProducts);
      
//     } catch (error) {
//       ToastService.error('Failed to load products');
//       console.error('Load products error:', error);
//     }
//   };

//   const refreshStockData = async () => {
//     try {
//       if (saleData.inventoryId) {
//         await loadStockAndProducts(saleData.inventoryId);
//         console.log('Stock data refreshed via polling');
//       }
//     } catch (error) {
//       console.error('Polling refresh error:', error);
//     }
//   };

//   const loadCustomerCreditBalance = async (customerId, routeId) => {
//     try {
//       const balanceData = await SaleService.getCustomerCreditBalance(customerId, routeId);
//       setOutstandingBalance(balanceData.balance || 0);
//     } catch (error) {
//       setOutstandingBalance(0);
//       console.error('Load credit balance error:', error);
//     }
//   };

//   const handleCustomerChange = async (customerId) => {
//     setSaleData(prev => ({ ...prev, customerId }));
//     await loadCustomerCreditBalance(customerId, saleData.routeId);
//   };

//   const handleRouteChange = async (routeId) => {
//     setSaleData(prev => ({ ...prev, routeId }));
//     await loadCustomers(routeId);
//   };

//   const handleCategoryChange = (categoryId) => {
//     setCurrentProduct(prev => ({ 
//       ...prev, 
//       categoryId, 
//       productId: '',
//       productName: '',
//       pricePerUnit: 0,
//       availableStock: 0,
//       unit: ''
//     }));
    
//     if (categoryId) {
//       const filtered = products.filter(product => 
//         product.categoryId && product.categoryId.toString() === categoryId.toString()
//       );
//       setFilteredProducts(filtered);
//     } else {
//       setFilteredProducts(products);
//     }
//   };

//   const handleProductChange = (productId) => {
//     const product = products.find(p => p.id.toString() === productId.toString());
//     if (product) {
//       setCurrentProduct(prev => ({
//         ...prev,
//         productId: product.id,
//         productName: product.name,
//         pricePerUnit: product.price,
//         availableStock: product.availableStock,
//         unit: 'units'
//       }));
//     }
//   };

//   const handleQuantityChange = (quantity) => {
//     const qty = parseInt(quantity) ;
//     setCurrentProduct(prev => ({ ...prev, quantity: Math.max(1, qty) }));
//   };

//   const handlePriceChange = (price) => {
//     const priceVal = parseFloat(price);
//     setCurrentProduct(prev => ({ ...prev, pricePerUnit: Math.max(0, priceVal) }));
//   };

//   const addProductToCart = () => {
//     if (!currentProduct.productId || !currentProduct.categoryId) {
//       ToastService.error('Please select a product');
//       return;
//     }

//     if (currentProduct.quantity <= 0) {
//       ToastService.error('Please enter a valid quantity');
//       return;
//     }

//     const product = products.find(p => p.id.toString() === currentProduct.productId.toString());
//     if (!product) {
//       ToastService.error('Product not found');
//       return;
//     }

//     // Check stock with optimistic updates
//     if (currentProduct.quantity > product.availableStock) {
//       ToastService.error(`Only ${product.availableStock} units available`);
//       return;
//     }

//     // Apply optimistic stock update
//     const updatedOptimisticUpdates = {
//       ...optimisticStockUpdates,
//       [product.id]: (optimisticStockUpdates[product.id] || 0) + currentProduct.quantity
//     };
//     setOptimisticStockUpdates(updatedOptimisticUpdates);

//     // Update products list with optimistic stock
//     const updatedProducts = products.map(p => 
//       p.id === product.id 
//         ? { ...p, availableStock: p.availableStock - currentProduct.quantity }
//         : p
//     );
    
//     setProducts(updatedProducts);
    
//     // Update filtered products
//     if (currentProduct.categoryId) {
//       const updatedFiltered = filteredProducts.map(p =>
//         p.id === product.id
//           ? { ...p, availableStock: p.availableStock - currentProduct.quantity }
//           : p
//       );
//       setFilteredProducts(updatedFiltered);
//     }

//     const newItem = {
//       id: product.id,
//       productId: product.id,
//       name: product.name,
//       pricePerUnit: currentProduct.pricePerUnit,
//       quantity: currentProduct.quantity,
//       total: currentProduct.pricePerUnit * currentProduct.quantity,
//       type: 'sale',
//       categoryId: product.categoryId,
//       categoryName: product.categoryName
//     };

//     setCartItems(prev => [...prev, newItem]);
    
//     // Update sale data products
//     setSaleData(prev => ({
//       ...prev,
//       products: [...prev.products, {
//         productId: product.id,
//         categoryId: product.categoryId,
//         pricePerUnit: currentProduct.pricePerUnit,
//         qty: currentProduct.quantity,
//         name: product.name,
//         categoryName: product.categoryName
//       }]
//     }));

//     // Reset current product
//     setCurrentProduct({
//       categoryId: '',
//       productId: '',
//       quantity: 1,
//       pricePerUnit: 0,
//       availableStock: 0,
//       productName: '',
//       unit: ''
//     });
    
//     setFilteredProducts(updatedProducts.filter(p => p.isActive));

//     ToastService.success('Product added to cart');
//   };

//   const addReturnToCart = () => {
//     const returnAmt = parseFloat(returnAmount);
//     if (isNaN(returnAmt) || returnAmt <= 0) {
//       ToastService.error('Please enter a valid return amount');
//       return;
//     }

//     // Check if return amount is reasonable
//     const saleTotal = cartItems
//       .filter(item => item.type === 'sale')
//       .reduce((sum, item) => sum + item.total, 0);
    
//     if (returnAmt > saleTotal) {
//       ToastService.error('Return amount cannot exceed total sale amount');
//       return;
//     }

//     const returnItem = {
//       id: `return_${Date.now()}`,
//       amount: returnAmt,
//       type: 'return',
//       name: 'Sale Return (Deduction)'
//     };

//     setCartItems(prev => [...prev, returnItem]);
//     setReturnAmount('');
    
//     // Update sale data return
//     setSaleData(prev => ({
//       ...prev,
//       productreturnData: { amount: returnAmt }
//     }));

//     ToastService.success('Return added to cart');
//   };

//   const removeCartItem = (index) => {
//     const newCartItems = [...cartItems];
//     const removedItem = newCartItems.splice(index, 1)[0];
    
//     // If it's a sale item, restore optimistic stock
//     if (removedItem.type === 'sale') {
//       const updatedOptimisticUpdates = { ...optimisticStockUpdates };
//       if (updatedOptimisticUpdates[removedItem.id]) {
//         updatedOptimisticUpdates[removedItem.id] -= removedItem.quantity;
//         if (updatedOptimisticUpdates[removedItem.id] <= 0) {
//           delete updatedOptimisticUpdates[removedItem.id];
//         }
//       }
//       setOptimisticStockUpdates(updatedOptimisticUpdates);
      
//       // Restore stock in UI
//       const updatedProducts = products.map(p => 
//         p.id === removedItem.id 
//           ? { ...p, availableStock: p.availableStock + removedItem.quantity }
//           : p
//       );
      
//       setProducts(updatedProducts);
      
//       if (currentProduct.categoryId) {
//         const updatedFiltered = filteredProducts.map(p =>
//           p.id === removedItem.id
//             ? { ...p, availableStock: p.availableStock + removedItem.quantity }
//             : p
//         );
//         setFilteredProducts(updatedFiltered);
//       }
//     }
    
//     setCartItems(newCartItems);
    
//     // Update sale data
//     if (removedItem.type === 'sale') {
//       setSaleData(prev => ({
//         ...prev,
//         products: prev.products.filter((_, i) => i !== index)
//       }));
//     } else if (removedItem.type === 'return') {
//       setSaleData(prev => ({
//         ...prev,
//         productreturnData: null
//       }));
//     }
    
//     ToastService.info('Item removed from cart');
//   };

//   // Calculate totals
//   const calculateTotals = useCallback(() => {
//     const subTotal = cartItems
//       .filter(item => item.type === 'sale')
//       .reduce((sum, item) => sum + (item.pricePerUnit * item.quantity), 0);
    
//     const returns = cartItems
//       .filter(item => item.type === 'return')
//       .reduce((sum, item) => sum + item.amount, 0);
    
//     const netTotal = subTotal - returns;
//     const paidAmount = saleData.paymentMethods.reduce((sum, payment) => sum + (payment.amount || 0), 0);
//     const remainingBalance = Math.max(0, netTotal - paidAmount);
//     const collectedAmount = tempCollections.reduce((sum, col) => sum + col.amount, 0);
//     const newOutstandingBalance = Math.max(0, outstandingBalance - collectedAmount);
    
//     return {
//       subTotal,
//       returns,
//       netTotal,
//       paidAmount,
//       remainingBalance,
//       collectedAmount,
//       newOutstandingBalance,
//       isFullyPaid: remainingBalance <= 0,
//       changeDue: Math.abs(Math.min(0, netTotal - paidAmount))
//     };
//   }, [cartItems, saleData.paymentMethods, tempCollections, outstandingBalance]);

//   const totals = calculateTotals();

//   const openPaymentModal = () => {
//     if (cartItems.length === 0) {
//       ToastService.error('Please add items to cart first');
//       return;
//     }
    
//     if (!saleData.customerId) {
//       ToastService.error('Please select a customer');
//       return;
//     }
    
//     setTempPayments(saleData.paymentMethods);
//     setShowPaymentModal(true);
//   };

//   const openCollectionModal = () => {
//     if (!saleData.customerId) {
//       ToastService.error('Please select a customer');
//       return;
//     }
    
//     if (outstandingBalance <= 0) {
//       ToastService.info('Customer has no outstanding balance');
//       return;
//     }
    
//     setCollectionInput(prev => ({ ...prev, amount: outstandingBalance.toFixed(2) }));
//     setTempCollections([]);
//     setShowCollectionModal(true);
//   };

//   const addPayment = () => {
//     const amount = parseFloat(paymentInput.amount);
//     if (isNaN(amount) || amount <= 0) {
//       ToastService.error('Please enter a valid amount');
//       return;
//     }

//     const totals = calculateTotals();
//     const existingPayments = tempPayments.reduce((sum, p) => sum + p.amount, 0);
//     const remainingBalance = totals.netTotal - existingPayments;
    
//     if (amount > remainingBalance && paymentInput.method !== 'CREDIT') {
//       ToastService.error(`Payment amount exceeds remaining balance of Rs. ${remainingBalance.toFixed(2)}`);
//       return;
//     }

//     if (paymentInput.method === 'CREDIT') {
//       const newCreditBalance = outstandingBalance + amount;
//       // Check credit limit if needed
//     }

//     const newPayment = {
//       method: paymentInput.method,
//       amount: amount
//     };

//     // Add additional details for specific payment methods
//     if (paymentInput.method === 'CHEQUE') {
//       if (!paymentInput.chequeNumber || !paymentInput.bank) {
//         ToastService.error('Cheque number and bank are required');
//         return;
//       }
//       newPayment.chequeNumber = paymentInput.chequeNumber;
//       newPayment.bank = paymentInput.bank;
//     }

//     if (paymentInput.method === 'BANK_TRANSFER') {
//       if (!paymentInput.reference) {
//         ToastService.error('Reference number is required');
//         return;
//       }
//       newPayment.reference = paymentInput.reference;
//     }

//     setTempPayments(prev => [...prev, newPayment]);
    
//     // Reset payment input
//     setPaymentInput({
//       method: 'CASH',
//       amount: '',
//       chequeNumber: '',
//       bank: '',
//       reference: ''
//     });

//     ToastService.success('Payment added');
//   };

//   const addCollectionPayment = () => {
//     const amount = parseFloat(collectionInput.amount);
//     if (isNaN(amount) || amount <= 0) {
//       ToastService.error('Please enter a valid amount');
//       return;
//     }

//     const totalCollected = tempCollections.reduce((sum, col) => sum + col.amount, 0);
//     const remainingDebt = outstandingBalance - totalCollected;
    
//     if (amount > remainingDebt) {
//       ToastService.error(`Collection amount cannot exceed remaining debt of Rs. ${remainingDebt.toFixed(2)}`);
//       return;
//     }

//     const newCollection = {
//       method: collectionInput.method,
//       amount: amount
//     };

//     // Add additional details for specific payment methods
//     if (collectionInput.method === 'CHEQUE') {
//       if (!collectionInput.chequeNumber || !collectionInput.bank) {
//         ToastService.error('Cheque number and bank are required');
//         return;
//       }
//       newCollection.chequeNumber = collectionInput.chequeNumber;
//       newCollection.bank = collectionInput.bank;
//     }

//     if (collectionInput.method === 'BANK_TRANSFER') {
//       if (!collectionInput.reference) {
//         ToastService.error('Reference number is required');
//         return;
//       }
//       newCollection.reference = collectionInput.reference;
//     }

//     setTempCollections(prev => [...prev, newCollection]);
    
//     // Update collection input amount for next entry
//     const newRemainingDebt = Math.max(0, remainingDebt - amount);
//     setCollectionInput(prev => ({ 
//       ...prev, 
//       amount: newRemainingDebt.toFixed(2),
//       chequeNumber: '',
//       bank: '',
//       reference: ''
//     }));

//     ToastService.success('Collection payment added');
//   };

//   const confirmPayments = () => {
//     if (tempPayments.length === 0 && totals.netTotal > 0) {
//       ToastService.error('Please add at least one payment method');
//       return;
//     }

//     // Validate payment methods
//     const totalPaid = tempPayments.reduce((sum, p) => sum + p.amount, 0);
//     const remaining = totals.netTotal - totalPaid;
    
//     if (remaining > 0) {
//       ToastService.error(`Net total must be fully covered by payments. Remaining: Rs. ${remaining.toFixed(2)}`);
//       return;
//     }

//     setSaleData(prev => ({
//       ...prev,
//       paymentMethods: tempPayments
//     }));
    
//     setShowPaymentModal(false);
//     ToastService.success('Payments confirmed');
//   };

//   const confirmCollections = async () => {
//     if (tempCollections.length === 0) {
//       ToastService.error('Please add at least one collection payment');
//       return;
//     }

//     try {
//       // Prepare collection data
//       const collectionData = {
//         customerId: saleData.customerId,
//         routeId: saleData.routeId,
//         payments: tempCollections.map(collection => ({
//           amount: collection.amount,
//           method: collection.method,
//           ...(collection.chequeNumber && { chequeNumber: collection.chequeNumber }),
//           ...(collection.bank && { bank: collection.bank }),
//           ...(collection.reference && { reference: collection.reference })
//         }))
//       };
      
//       // Process debt collection
//       await SaleService.processDebtCollection(collectionData);
      
//       // Update outstanding balance
//       const totalCollected = tempCollections.reduce((sum, col) => sum + col.amount, 0);
//       const newBalance = Math.max(0, outstandingBalance - totalCollected);
//       setOutstandingBalance(newBalance);
      
//       setShowCollectionModal(false);
//       setTempCollections([]);
//       ToastService.success('Collections processed successfully');
      
//     } catch (error) {
//       ToastService.error('Failed to process collections: ' + (error.message || 'Network error'));
//       console.error('Process collections error:', error);
//     }
//   };

//   const removeTempPayment = (index) => {
//     const newPayments = [...tempPayments];
//     newPayments.splice(index, 1);
//     setTempPayments(newPayments);
//     ToastService.info('Payment removed');
//   };

//   const removeTempCollection = (index) => {
//     const newCollections = [...tempCollections];
//     newCollections.splice(index, 1);
//     setTempCollections(newCollections);
    
//     // Update collection input amount
//     const totalCollected = newCollections.reduce((sum, col) => sum + col.amount, 0);
//     const remainingBalance = Math.max(0, outstandingBalance - totalCollected);
//     setCollectionInput(prev => ({ ...prev, amount: remainingBalance.toFixed(2) }));
    
//     ToastService.info('Collection removed');
//   };

//   // const handleCompleteSale = async () => {
//   //   if (!totals.isFullyPaid) {
//   //     ToastService.error('Sale must be fully paid before completing');
//   //     return;
//   //   }

//   //   if (saleData.products.length === 0) {
//   //     ToastService.error('Please add at least one product');
//   //     return;
//   //   }

//   //   if (!saleData.customerId || !saleData.routeId || !saleData.inventoryId) {
//   //     ToastService.error('Please fill all required fields');
//   //     return;
//   //   }

//   //   // Validate sale data using SaleService
//   //   const validation = SaleService.validateSaleData(saleData);
//   //   if (!validation.isValid) {
//   //     ToastService.error(validation.errors[0]);
//   //     return;
//   //   }

//   //   try {
//   //     setProcessingSale(true);
      
//   //     // Prepare sale data
//   //     const preparedData = SaleService.prepareSaleData(saleData);
      
//   //     // Create sale
//   //     const result = await SaleService.createSale(preparedData);
      
//   //     ToastService.success('Sale completed successfully!');
      
//   //     // Load new invoice number
//   //     await loadInvoiceNumber();
      
//   //     // Clear optimistic updates since sale was successful
//   //     setOptimisticStockUpdates({});
      
//   //     // IMPORTANT: Refresh stock data after successful sale
//   //     await loadStockAndProducts(saleData.inventoryId);
      
//   //     // Reset form for next sale
//   //     resetSaleForm();
      
//   //   } catch (error) {
//   //     ToastService.error('Failed to complete sale: ' + (error.message || 'Network error'));
//   //     console.error('Complete sale error:', error);
      
//   //     // If sale fails, refresh stock to get accurate data
//   //     if (saleData.inventoryId) {
//   //       await loadStockAndProducts(saleData.inventoryId);
//   //     }
//   //   } finally {
//   //     setProcessingSale(false);
//   //   }
//   // };

//   const handleCompleteSale = async () => {
//   if (!totals.isFullyPaid) {
//     ToastService.error('Sale must be fully paid before completing');
//     return;
//   }
//   if (saleData.products.length === 0) {
//     ToastService.error('Please add at least one product');
//     return;
//   }
//   if (!saleData.customerId || !saleData.routeId || !saleData.inventoryId) {
//     ToastService.error('Please fill all required fields');
//     return;
//   }

//   const validation = SaleService.validateSaleData(saleData);
//   if (!validation.isValid) {
//     ToastService.error(validation.errors[0]);
//     return;
//   }

//   try {
//     setProcessingSale(true);
//     const preparedData = SaleService.prepareSaleData(saleData);
    
//     // Save to Database
//     const result = await SaleService.createSale(preparedData);
    
//     console.log('Sale result:', result);
//     console.log('Characteristic available:', characteristic ? 'Yes' : 'No');
    
//     // AUTOMATIC PRINTING with actual sales data
//     if (characteristic && characteristic.writeValue) {
//       try {
//         console.log('Attempting to print receipt...');
        
//         // Generate receipt with actual sales data
//         const receiptData = await generateReceiptWithActualData({
//           saleResult: result,
//           cartItems: cartItems.filter(item => item.type === 'sale'),
//           totals: calculateTotals(),
//           saleData: saleData,
//           customers: customers,
//           routes: routes,
//           currentUser: AuthService.getCurrentUser()
//         });
        
//         console.log('Receipt generated, size:', receiptData.byteLength, 'bytes');
        
//         // Write to printer in chunks (same as printTest)
//         const CHUNK_SIZE = 480;
//         const buffer = receiptData;
//         const totalBytes = buffer.byteLength;
//         let offset = 0;
        
//         console.log(`Writing receipt (${totalBytes} bytes)...`);
        
//         while (offset < totalBytes) {
//           const chunkSize = Math.min(CHUNK_SIZE, totalBytes - offset);
//           const chunk = buffer.slice(offset, offset + chunkSize);
          
//           await characteristic.writeValue(chunk);
//           console.log(`Written chunk: ${chunkSize} bytes`);
          
//           // Small delay between chunks (same as printTest)
//           await new Promise(resolve => setTimeout(resolve, 50));
          
//           offset += chunkSize;
//         }
        
//         console.log('Receipt printed successfully!');
//         ToastService.success('Sale completed and receipt printed!');
        
//       } catch (printError) {
//         console.error('Printing failed:', printError);
//         ToastService.success('Sale completed, but receipt could not be printed.');
//       }
//     } else {
//       console.warn('No printer connected or writeValue not available');
//       ToastService.success('Sale completed successfully! (No printer connected)');
//     }

//     // Cleanup & Refresh
//     setOptimisticStockUpdates({});
//     resetSaleForm();
    
//     // Load fresh data after a short delay
//     setTimeout(async () => {
//       try {
//         await loadInvoiceNumber();
//         if (saleData.inventoryId) {
//           await loadStockAndProducts(saleData.inventoryId);
//         }
//       } catch (refreshError) {
//         console.error('Failed to refresh data:', refreshError);
//       }
//     }, 500);
    
//   } catch (error) {
//     console.error('Sale completion failed:', error);
//     ToastService.error('Failed to complete sale: ' + (error.message || 'Network error'));
    
//     // Refresh stock data
//     if (saleData.inventoryId) {
//       try {
//         await loadStockAndProducts(saleData.inventoryId);
//       } catch (refreshError) {
//         console.error('Failed to refresh stock:', refreshError);
//       }
//     }
//   } finally {
//     setProcessingSale(false);
//   }
// };

// // Generate receipt with actual sales data (using same design as printTest)
// const generateReceiptWithActualData = async ({ 
//   saleResult, 
//   cartItems, 
//   totals, 
//   saleData, 
//   customers, 
//   routes,
//   currentUser 
// }) => {
//   const encoder = new EscPosEncoder();
  
//   // Get actual data from the sale
//   const customer = customers.find(c => c.id.toString() === saleData.customerId.toString());
//   const route = routes.find(r => r.id.toString() === saleData.routeId.toString());
  
//   // Invoice number from sale result or generated
//   const invoiceNum = saleResult.invoiceNumber || saleResult.data?.invoiceNumber || invoiceNumber;
//   const currentTime = new Date().toLocaleTimeString('en-US', { 
//     hour: '2-digit', 
//     minute: '2-digit',
//     hour12: true 
//   });
//   const currentDate = new Date().toLocaleDateString('en-GB');
  
//   // Business information (you can customize these)
//   const businessName = "Sayul Redistributions";
//     const businessAddress = "NO 244/2/A.Makola, North, Makola";
//     const businessPhone = "Tel: +94 77 222 2700";
  
//   // Customer actual data
//   const customerName = customer?.name || "Cash Customer";

  
//   // Sales info actual data


//         // Also try to get route name from other localStorage items if available
      
//   const salesRep = currentUser?.firstName || "Sales Rep";
//   const routeName = route?.name || "Route";
//   const inventory ='inventoryInfo.name'
// // You can get this from your inventory data if available

//   // Actual product items from cart
//   const saleProducts = cartItems.filter(item => item.type === 'sale');
  
//   // Actual payments from sale data
//   const actualPayments = saleData.paymentMethods || [];
  
//   // Actual totals
//   const subTotal = totals.subTotal || 0;
//   const returns = totals.returns || 0;
//   const netTotal = totals.netTotal || 0;
//   const paidAmount = totals.paidAmount || 0;
//   const remainingBalance = totals.remainingBalance || 0;
//   const changeDue = totals.changeDue || 0;

//   // Build the receipt with ACTUAL data (same structure as printTest)
//   const receipt = encoder
//     .initialize()
//     .codepage('cp858')
    
//     // ==================== BUSINESS HEADER ====================
//     .align('center')
//     .size(2, 2)
//     .bold(true)
//     .line(   businessName)
//     .line(' ')
//     .size(1, 1)
//     .bold(false)
//     .line(businessAddress)
//     .line(businessPhone)
//     .line(' ')
//     .line('='.repeat(42))
    
//     // ==================== INVOICE DETAILS ====================
//     .align('left')
//     .bold(true)
//     .line('INVOICE DETAILS')
//     .bold(false)
//     .line('─'.repeat(42))
//     .line(`Invoice # : ${invoiceNum}`)
//     .line(`Date/Time : ${currentDate} ${currentTime}`)
//     .line(`Customer  : ${customerName.substring(0, 20)}`)
//     .line(`Sales Rep : ${salesRep.substring(0, 15)}`)
//     .line(`Route     : ${routeName.substring(0, 15)}`)
//     .line(`Inventory : ${inventory.substring(0, 15)}`)
//     .line('='.repeat(42))
    
//     // ==================== PRODUCTS SECTION ====================
//     .align('center')
//     .bold(true)
//     .line('PRODUCTS')
//     .bold(false)
//     .line('─'.repeat(42))
    
//     // Table Header
//     .align('center')
//     .bold(true)
//     .line('   Category    Product        Qty   Price')
//     .bold(false)
//     .line('─'.repeat(42));
  
//   // Add ACTUAL products (limit to 10 items for receipt space)
//   const displayProducts = saleProducts.slice(0, 10);
//   displayProducts.forEach(item => {
//     const category = (item.categoryName || 'GEN').substring(0, 11).padEnd(11);
//     const product = (item.name || 'Item').substring(0, 14).padEnd(15);
//     const qty = (item.quantity || 0).toString().padStart(3);
//     const price = (item.pricePerUnit || 0).toFixed(2).padStart(8);
    
//     receipt.line(`${category}${product}${qty}${price}`);
//   });
  
//   // If there were more items, show a summary
//   if (saleProducts.length > 10) {
//     receipt.line(`... and ${saleProducts.length - 10} more items`);
//   }
  
//   receipt.line('─'.repeat(42));
  
//   // ==================== TOTALS ====================
//   receipt
//     .align('right')
//     .line(`Sub Total: ${subTotal.toFixed(2).padStart(10)}`);
  
//   // Returns (if any)
//   if (returns > 0) {
//     receipt.line(`Returns  : -${returns.toFixed(2).padStart(10)}`);
//   }
  
//   receipt.line('─'.repeat(42));
  
//   // ==================== PAYMENT METHODS ====================
//   if (actualPayments.length > 0) {
//     receipt
//       .align('left')
//       .bold(true)
//       .line('PAYMENT METHODS')
//       .bold(false)
//       .line('─'.repeat(42));
    
//     actualPayments.forEach(payment => {
//       const method = (payment.method || 'CASH').substring(0, 16).padEnd(16);
//       const amount = (payment.amount || 0).toFixed(2).padStart(10);
//       receipt.line(`${method}${amount}`);
//     });
    
//     receipt.line('─'.repeat(42));
//   }
  
//   // ==================== FINAL TOTAL ====================
//   receipt
//     .align('right')
//     .bold(true)
//     .size('double')
//     .line('─'.repeat(42))
//     .line(`TOTAL: Rs.${netTotal.toFixed(2).padStart(10)}`)
//     .size('normal')
//     .bold(false)
//     .line('─'.repeat(42));
  
//   // ==================== PAYMENT SUMMARY ====================
//   receipt
//     .align('left')
//     .line(`Paid Amount: ${paidAmount.toFixed(2).padStart(10)}`);
  
//   if (remainingBalance > 0) {
//     receipt.line(`Balance Due: ${remainingBalance.toFixed(2).padStart(10)}`);
//   } else if (changeDue > 0) {
//     receipt.line(`Change Due : ${changeDue.toFixed(2).padStart(10)}`);
//   } else {
//     receipt.line(`Payment    : FULLY PAID`);
//   }
  
//   // ==================== FOOTER ====================
//   receipt
//     .line('='.repeat(42))
//     .line(' ')
//     .align('center')
//     .bold(true)
//     .line('THANK YOU!')
//     .bold(false)
//     .line('We value your business')
//     .line('Please visit again')
//     .newline()
//     .newline()
//     .cut('partial');
  
//   // ENCODE the receipt
//   const encodedData = receipt.encode();
  
//   console.log('Receipt size:', encodedData.byteLength, 'bytes');
//   return encodedData;
// };

// // Helper function to write data in chunks (keep this for safety)
// const writeDataInChunks = async (characteristic, data) => {
//   const CHUNK_SIZE = 480;
  
//   const buffer = data instanceof ArrayBuffer ? data : 
//                  data.buffer instanceof ArrayBuffer ? data.buffer : 
//                  new Uint8Array(data).buffer;
  
//   const totalBytes = buffer.byteLength;
//   let offset = 0;
  
//   console.log(`Total bytes to write: ${totalBytes}`);
  
//   while (offset < totalBytes) {
//     const chunkSize = Math.min(CHUNK_SIZE, totalBytes - offset);
//     const chunk = buffer.slice(offset, offset + chunkSize);
    
//     await characteristic.writeValue(chunk);
//     console.log(`Written chunk: ${chunkSize} bytes (${offset + chunkSize}/${totalBytes})`);
    
//     await new Promise(resolve => setTimeout(resolve, 50));
    
//     offset += chunkSize;
//   }
  
//   console.log('All data written successfully');
// };


//   const resetSaleForm = () => {
//     // Reset all state but keep route and inventory
//     setSaleData(prev => ({
//       ...prev, // Keep routeId and inventoryId
//       customerId: '',
//       products: [],
//       paymentMethods: [],
//       productreturnData: null
//     }));
    
//     setCartItems([]);
//     setTempPayments([]);
//     setTempCollections([]);
//     setCurrentProduct({
//       categoryId: '',
//       productId: '',
//       quantity: 1,
//       pricePerUnit: 0,
//       availableStock: 0,
//       productName: '',
//       unit: ''
//     });
    
//     setReturnAmount('');
//     setPaymentInput({
//       method: 'CASH',
//       amount: '',
//       chequeNumber: '',
//       bank: '',
//       reference: ''
//     });
    
//     // Reset outstanding balance
//     setOutstandingBalance(0);
    
//     // Reload customers for current route
//     if (saleData.routeId) {
//       loadCustomers(saleData.routeId);
//     }
    
//     ToastService.info('Form reset for next sale');
//   };

//   const handleCancelSale = () => {
//     if (cartItems.length > 0 || saleData.paymentMethods.length > 0) {
//       if (window.confirm('Are you sure you want to cancel this sale? All items and payments will be cleared.')) {
//         // Clear optimistic updates
//         setOptimisticStockUpdates({});
        
//         // Refresh stock data
//         if (saleData.inventoryId) {
//           loadStockAndProducts(saleData.inventoryId);
//         }
        
//         resetSaleForm();
//         ToastService.info('Sale cancelled');
//       }
//     } else {
//       resetSaleForm();
//     }
//   };

//   const formatCurrency = (amount) => {
//     return `Rs. ${Math.abs(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
//   };

//   const getSelectedCustomerName = () => {
//     const customer = customers.find(c => c.id === saleData.customerId);
//     return customer ? `${customer.name} (${customer.code || customer.id})` : 'No customer selected';
//   };

//   if (loading.customers || loading.routes || loading.products) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading sale interface...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="create-sale-container">
//       {/* Header with polling indicator */}
//       <div className="sale-header">
//         <div className="header-top">
//           <h1>Create Sale</h1>
//           <div className="polling-indicator">
//             <i className="fas fa-sync-alt"></i> Auto-refresh: 30s
//           </div>
//         </div>
//         <div className="invoice-info">
//           <span><i className="fas fa-file-invoice"></i> Invoice: {invoiceNumber}</span>
//           <span><i className="fas fa-calendar"></i> Date: {new Date().toLocaleDateString()}</span>
//           <span><i className="fas fa-user"></i> Customer: {getSelectedCustomerName()}</span>
//         </div>
//       </div>

//       {/* Customer & Route Section */}
//       <div className="sale-card">
//         <h3>Customer & Route Details</h3>
//         <div className="customer-row">
//           <div className="form-group">
//             <label htmlFor="customerSelect">Customer</label>
//             <select 
//               id="customerSelect"
//               value={saleData.customerId}
//               onChange={(e) => handleCustomerChange(e.target.value)}
//               className="form-select"
//             >
//               <option value="">Select Customer</option>
//               {customers.map(customer => (
//                 <option key={customer.id} value={customer.id}>
//                   {customer.name} ({customer.code || customer.id})
//                 </option>
//               ))}
//             </select>
//           </div>
          
//           <div className="form-group">
//             <label htmlFor="routeSelect">Route</label>
//             <select 
//               id="routeSelect"
//               value={saleData.routeId}
//               onChange={(e) => handleRouteChange(e.target.value)}
//               className="form-select"
//               disabled={!ShiftService.isShiftActive()}
//             >
//               <option value="">Select Route</option>
//               {routes.map(route => (
//                 <option key={route.id} value={route.id}>
//                   {route.name || `Route ${route.id}`}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
        
//         <div className="customer-info">
//           <div className="info-item">
//             <span>Customer Code:</span>
//             <strong>
//               {saleData.customerId ? 
//                 customers.find(c => c.id === saleData.customerId)?.code || 'N/A' : 
//                 'N/A'}
//             </strong>
//           </div>
//           <div className="info-item">
//             <span>Outstanding Balance:</span>
//             <strong className={outstandingBalance > 0 ? 'balance-danger' : 'balance-safe'}>
//               {formatCurrency(outstandingBalance)}
//             </strong>
//           </div>
//         </div>
//       </div>

//       {/* Product Selection Section */}
//       <div className="sale-card">
//         <h3>Add Products</h3>
//         <div className="product-selection-row">
//           <div className="form-group">
//             <label htmlFor="categorySelect">Category</label>
//             <select 
//               id="categorySelect"
//               value={currentProduct.categoryId}
//               onChange={(e) => handleCategoryChange(e.target.value)}
//               className="form-select"
//             >
//               <option value="">All Categories</option>
//               {categories.map(category => (
//                 <option key={category.id} value={category.id}>
//                   {category.name}
//                 </option>
//               ))}
//             </select>
//           </div>
          
//           <div className="form-group">
//             <label htmlFor="productSelect">Product</label>
//             <select 
//               id="productSelect"
//               value={currentProduct.productId}
//               onChange={(e) => handleProductChange(e.target.value)}
//               className="form-select"
//             >
//               <option value="">Select Product</option>
//               {filteredProducts.map(product => (
//                 <option 
//                   key={product.id} 
//                   value={product.id} 
//                   disabled={product.availableStock <= 0}
//                   className={product.availableStock <= 0 ? 'out-of-stock' : ''}
//                 >
//                   {product.name} - {formatCurrency(product.price)} 
//                   <span className={`stock-badge ${product.availableStock <= 5 ? 'low-stock' : 'in-stock'}`}>
//                     (Stock: {product.availableStock})
//                   </span>
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
        
//         {currentProduct.productId && (
//           <div className="selected-product-info">
//             <div className="info-row">
//               <span>Selected:</span>
//               <strong>{currentProduct.productName}</strong>
//             </div>
//             <div className="info-row">
//               <span>Category:</span>
//               <strong>{categories.find(c => c.id.toString() === currentProduct.categoryId.toString())?.name || 'N/A'}</strong>
//             </div>
//           </div>
//         )}
        
//         <div className="product-details-row">
//           <div className="form-group">
//             <label htmlFor="quantity">Quantity</label>
//             <input 
//               type="number" 
//               id="quantity"
//               value={currentProduct.quantity}
//               onChange={(e) => handleQuantityChange(e.target.value)}
//               min="1"
//               max={currentProduct.availableStock}
//               className="form-input"
//               disabled={!currentProduct.productId}
//             />
//           </div>
          
//           <div className="form-group">
//             <label htmlFor="price">Unit Price (Rs.)</label>
//             <input 
//               type="number" 
//               id="price"
//               value={currentProduct.pricePerUnit}
//               onChange={(e) => handlePriceChange(e.target.value)}
//               min="0"
//               step="0.01"
//               className="form-input"
//               disabled={!currentProduct.productId}
//             />
//           </div>
          
//           <div className="form-group">
//             <label>Available Stock</label>
//             <div className={`stock-display ${currentProduct.availableStock <= 5 ? 'stock-low' : 'stock-ok'}`}>
//               {currentProduct.availableStock}
//             </div>
//           </div>
          
//           <button 
//             onClick={addProductToCart}
//             className="btn-add-product"
//             disabled={!currentProduct.productId || currentProduct.quantity <= 0 || currentProduct.quantity > currentProduct.availableStock}
//           >
//             <i className="fas fa-cart-plus"></i> Add
//           </button>
//         </div>
//       </div>

//       {/* Return Section */}
//       <div className="sale-card return-card">
//         <h3><i className="fas fa-undo"></i> Process Return</h3>
//         <div className="return-row">
//           <div className="form-group">
//             <label htmlFor="returnAmount">Return Amount (Rs.)</label>
//             <input 
//               type="number" 
//               id="returnAmount"
//               value={returnAmount}
//               onChange={(e) => setReturnAmount(e.target.value)}
//               min="0"
//               step="0.01"
//               className="form-input"
//               placeholder="Enter return amount"
//             />
//           </div>
//           <button 
//             onClick={addReturnToCart}
//             className="btn-add-return"
//             disabled={!returnAmount || parseFloat(returnAmount) <= 0}
//           >
//             <i className="fas fa-minus-circle"></i> Add Return
//           </button>
//         </div>
//       </div>

//       {/* Cart Items */}
//       <div className="sale-card cart-card">
//         <h3><i className="fas fa-shopping-cart"></i> Cart Items ({cartItems.length})</h3>
//         {cartItems.length === 0 ? (
//           <div className="empty-cart">
//             <i className="fas fa-cart-arrow-down"></i>
//             <p>No items in cart</p>
//           </div>
//         ) : (
//           <div className="cart-table-container">
//             <table className="cart-table">
//               <thead>
//                 <tr>
//                   <th>Item</th>
//                   <th>Qty</th>
//                   <th>Price</th>
//                   <th>Total</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {cartItems.map((item, index) => (
//                   <tr key={index} className={item.type === 'return' ? 'return-item' : 'sale-item'}>
//                     <td>
//                       <div className="item-name">
//                         {item.type === 'sale' ? item.name : 'Sale Return (Deduction)'}
//                         {item.type === 'sale' && item.categoryName && (
//                           <small className="category-tag"> {item.categoryName}</small>
//                         )}
//                       </div>
//                     </td>
//                     <td>{item.type === 'sale' ? item.quantity : '-'}</td>
//                     <td>
//                       {item.type === 'sale' ? formatCurrency(item.pricePerUnit) : '-'}
//                     </td>
//                     <td className={item.type === 'return' ? 'negative-amount' : 'positive-amount'}>
//                       {item.type === 'sale' ? formatCurrency(item.total) : formatCurrency(item.amount)}
//                     </td>
//                     <td>
//                       <button 
//                         onClick={() => removeCartItem(index)}
//                         className="btn-remove"
//                         title="Remove item"
//                       >
//                         <i className="fas fa-trash-alt"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* Summary Section */}
//       <div className="sale-card summary-card">
//         <h3><i className="fas fa-calculator"></i> Invoice Summary</h3>
//         <div className="summary-row">
//           <span>Sub Total:</span>
//           <span>{formatCurrency(totals.subTotal)}</span>
//         </div>
//         {totals.returns > 0 && (
//           <div className="summary-row">
//             <span>Returns:</span>
//             <span className="negative-amount">-{formatCurrency(totals.returns)}</span>
//           </div>
//         )}
//         <div className="summary-row grand-total">
//           <span>NET TOTAL:</span>
//           <span>{formatCurrency(totals.netTotal)}</span>
//         </div>
        
//         <div className="summary-row">
//           <span>Paid Amount:</span>
//           <span className="positive-amount">{formatCurrency(totals.paidAmount)}</span>
//         </div>
        
//         {totals.remainingBalance > 0 ? (
//           <div className="summary-row balance-due">
//             <span><i className="fas fa-exclamation-circle"></i> Balance Due:</span>
//             <span className="negative-amount">{formatCurrency(totals.remainingBalance)}</span>
//           </div>
//         ) : totals.changeDue > 0 ? (
//           <div className="summary-row change-due">
//             <span><i className="fas fa-exchange-alt"></i> Change Due:</span>
//             <span className="positive-amount">{formatCurrency(totals.changeDue)}</span>
//           </div>
//         ) : totals.netTotal > 0 ? (
//           <div className="summary-row paid-exact">
//             <span><i className="fas fa-check-circle"></i> Fully Paid</span>
//             <span className="positive-amount">{formatCurrency(0)}</span>
//           </div>
//         ) : null}
//       </div>

//       {/* Collection Section */}
//       {outstandingBalance > 0 && (
//         <div className="sale-card collection-card">
//           <h3><i className="fas fa-hand-holding-usd"></i> Debt Collection</h3>
//           <div className="collection-info">
//             <div className="info-item">
//               <span>Outstanding Debt:</span>
//               <strong className="balance-danger">{formatCurrency(outstandingBalance)}</strong>
//             </div>
//             <div className="info-item">
//               <span>Collected This Session:</span>
//               <strong className="positive-amount">{formatCurrency(totals.collectedAmount)}</strong>
//             </div>
//             {totals.collectedAmount > 0 && (
//               <div className="info-item">
//                 <span>New Balance:</span>
//                 <strong className={totals.newOutstandingBalance > 0 ? 'balance-danger' : 'balance-safe'}>
//                   {formatCurrency(totals.newOutstandingBalance)}
//                 </strong>
//               </div>
//             )}
//           </div>
//           <button 
//             onClick={openCollectionModal}
//             className="btn-collection"
//             disabled={processingSale}
//           >
//             <i className="fas fa-hand-holding-usd"></i> Record Debt Payment
//           </button>
//         </div>
//       )}

//       {/* Action Buttons */}
//       <div className="action-buttons">
//         <button 
//           onClick={handleCancelSale}
//           className="btn-cancel"
//           disabled={processingSale}
//         >
//           <i className="fas fa-times"></i> {cartItems.length > 0 ? 'Cancel Sale' : 'Clear'}
//         </button>
        
//         <button 
//           onClick={openPaymentModal}
//           className="btn-payment"
//           disabled={cartItems.length === 0 || processingSale}
//         >
//           <i className="fas fa-credit-card"></i> Take Payment
//         </button>
        
//         <button 
//           onClick={handleCompleteSale}
//           className="btn-complete"
//           disabled={!totals.isFullyPaid || processingSale || cartItems.length === 0}
//         >
//           {processingSale ? (
//             <>
//               <i className="fas fa-spinner fa-spin"></i> Processing...
//             </>
//           ) : (
//             <>
//               <i className="fas fa-check"></i> Complete Sale
//             </>
//           )}
//         </button>
//       </div>

//       {/* Payment Modal */}
//       {showPaymentModal && (
//         <div className="modal-overlay" onClick={() => setShowPaymentModal(false)}>
//           <div className="modal-content payment-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3><i className="fas fa-credit-card"></i> Take Payment</h3>
//               <button onClick={() => setShowPaymentModal(false)} className="btn-close">
//                 <i className="fas fa-times"></i>
//               </button>
//             </div>
            
//             <div className="modal-body">
//               <div className="payment-summary">
//                 <div className="summary-item">
//                   <span>Net Total:</span>
//                   <strong>{formatCurrency(totals.netTotal)}</strong>
//                 </div>
//                 <div className="summary-item">
//                   <span>Paid So Far:</span>
//                   <strong>{formatCurrency(totals.paidAmount)}</strong>
//                 </div>
//                 <div className="summary-item remaining-balance">
//                   <span>Remaining Balance:</span>
//                   <strong className={totals.remainingBalance > 0 ? 'negative-amount' : 'positive-amount'}>
//                     {formatCurrency(Math.abs(totals.netTotal - totals.paidAmount))}
//                   </strong>
//                 </div>
//               </div>
              
//               <div className="payment-input-row">
//                 <div className="form-group">
//                   <label>Payment Method</label>
//                   <select 
//                     value={paymentInput.method}
//                     onChange={(e) => setPaymentInput({...paymentInput, method: e.target.value})}
//                     className="form-select"
//                   >
//                     <option value="CASH">Cash</option>
//                     <option value="CHEQUE">Cheque</option>
//                     <option value="BANK_TRANSFER">Bank Transfer</option>
//                     <option value="CREDIT">Credit</option>
//                   </select>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Amount (Rs.)</label>
//                   <input 
//                     type="number"
//                     value={paymentInput.amount}
//                     onChange={(e) => setPaymentInput({...paymentInput, amount: e.target.value})}
//                     className="form-input"
//                     placeholder="Enter amount"
//                     step="0.01"
//                     min="0"
//                   />
//                 </div>
                
//                 <button onClick={addPayment} className="btn-add-payment">
//                   <i className="fas fa-plus"></i> Add
//                 </button>
//               </div>
              
//               {/* Additional fields for cheque/bank transfer */}
//               {paymentInput.method === 'CHEQUE' && (
//                 <div className="payment-details-row">
//                   <div className="form-group">
//                     <label>Cheque Number</label>
//                     <input 
//                       type="text"
//                       value={paymentInput.chequeNumber}
//                       onChange={(e) => setPaymentInput({...paymentInput, chequeNumber: e.target.value})}
//                       className="form-input"
//                       placeholder="Cheque number"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Bank Name</label>
//                     <input 
//                       type="text"
//                       value={paymentInput.bank}
//                       onChange={(e) => setPaymentInput({...paymentInput, bank: e.target.value})}
//                       className="form-input"
//                       placeholder="Bank name"
//                     />
//                   </div>
//                 </div>
//               )}
              
//               {paymentInput.method === 'BANK_TRANSFER' && (
//                 <div className="form-group">
//                   <label>Reference Number</label>
//                   <input 
//                     type="text"
//                     value={paymentInput.reference}
//                     onChange={(e) => setPaymentInput({...paymentInput, reference: e.target.value})}
//                     className="form-input"
//                     placeholder="Reference number"
//                   />
//                 </div>
//               )}
              
//               {/* Payment List */}
//               <div className="payment-list">
//                 <h4><i className="fas fa-list"></i> Recorded Payments</h4>
//                 {tempPayments.length === 0 ? (
//                   <p className="no-payments">No payments recorded</p>
//                 ) : (
//                   <>
//                     <table className="payments-table">
//                       <thead>
//                         <tr>
//                           <th>Method</th>
//                           <th>Amount</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {tempPayments.map((payment, index) => (
//                           <tr key={index}>
//                             <td>
//                               <span className={`payment-method ${payment.method.toLowerCase()}`}>
//                                 {payment.method}
//                               </span>
//                             </td>
//                             <td>{formatCurrency(payment.amount)}</td>
//                             <td>
//                               <button 
//                                 onClick={() => removeTempPayment(index)}
//                                 className="btn-remove-small"
//                                 title="Remove payment"
//                               >
//                                 <i className="fas fa-trash"></i>
//                               </button>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                     <div className="payment-total">
//                       <span>Total:</span>
//                       <strong>{formatCurrency(tempPayments.reduce((sum, p) => sum + p.amount, 0))}</strong>
//                     </div>
//                   </>
//                 )}
//               </div>
//             </div>
            
//             <div className="modal-footer">
//               <button 
//                 onClick={() => {
//                   setTempPayments([]);
//                   ToastService.info('Payments cleared');
//                 }}
//                 className="btn-secondary"
//                 disabled={tempPayments.length === 0}
//               >
//                 <i className="fas fa-trash"></i> Clear All
//               </button>
//               <button onClick={confirmPayments} className="btn-primary">
//                 <i className="fas fa-check"></i> Confirm Payments
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Collection Modal */}
//       {showCollectionModal && (
//         <div className="modal-overlay" onClick={() => setShowCollectionModal(false)}>
//           <div className="modal-content collection-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3><i className="fas fa-hand-holding-usd"></i> Record Debt Collection</h3>
//               <button onClick={() => setShowCollectionModal(false)} className="btn-close">
//                 <i className="fas fa-times"></i>
//               </button>
//             </div>
            
//             <div className="modal-body">
//               <div className="collection-summary">
//                 <div className="summary-item">
//                   <span>Outstanding Balance:</span>
//                   <strong className="balance-danger">{formatCurrency(outstandingBalance)}</strong>
//                 </div>
//                 <div className="summary-item">
//                   <span>Collected This Session:</span>
//                   <strong className="positive-amount">
//                     {formatCurrency(tempCollections.reduce((sum, col) => sum + col.amount, 0))}
//                   </strong>
//                 </div>
//                 <div className="summary-item">
//                   <span>Remaining After Collection:</span>
//                   <strong className="balance-danger">
//                     {formatCurrency(outstandingBalance - tempCollections.reduce((sum, col) => sum + col.amount, 0))}
//                   </strong>
//                 </div>
//               </div>
              
//               <div className="collection-input-row">
//                 <div className="form-group">
//                   <label>Payment Method</label>
//                   <select 
//                     value={collectionInput.method}
//                     onChange={(e) => setCollectionInput({...collectionInput, method: e.target.value})}
//                     className="form-select"
//                   >
//                     <option value="CASH">Cash</option>
//                     <option value="CHEQUE">Cheque</option>
//                     <option value="BANK_TRANSFER">Bank Transfer</option>
//                   </select>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Amount to Collect (Rs.)</label>
//                   <input 
//                     type="number"
//                     value={collectionInput.amount}
//                     onChange={(e) => setCollectionInput({...collectionInput, amount: e.target.value})}
//                     className="form-input"
//                     placeholder="Enter amount"
//                     step="0.01"
//                     min="0"
//                   />
//                 </div>
                
//                 <button onClick={addCollectionPayment} className="btn-add-collection">
//                   <i className="fas fa-plus"></i> Add
//                 </button>
//               </div>
              
//               {/* Additional fields for cheque/bank transfer */}
//               {collectionInput.method === 'CHEQUE' && (
//                 <div className="collection-details-row">
//                   <div className="form-group">
//                     <label>Cheque Number</label>
//                     <input 
//                       type="text"
//                       value={collectionInput.chequeNumber}
//                       onChange={(e) => setCollectionInput({...collectionInput, chequeNumber: e.target.value})}
//                       className="form-input"
//                       placeholder="Cheque number"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Bank Name</label>
//                     <input 
//                       type="text"
//                       value={collectionInput.bank}
//                       onChange={(e) => setCollectionInput({...collectionInput, bank: e.target.value})}
//                       className="form-input"
//                       placeholder="Bank name"
//                     />
//                   </div>
//                 </div>
//               )}
              
//               {collectionInput.method === 'BANK_TRANSFER' && (
//                 <div className="form-group">
//                   <label>Reference Number</label>
//                   <input 
//                     type="text"
//                     value={collectionInput.reference}
//                     onChange={(e) => setCollectionInput({...collectionInput, reference: e.target.value})}
//                     className="form-input"
//                     placeholder="Reference number"
//                   />
//                 </div>
//               )}
              
//               {/* Collection List */}
//               <div className="collection-list">
//                 <h4><i className="fas fa-list"></i> Recorded Collections</h4>
//                 {tempCollections.length === 0 ? (
//                   <p className="no-collections">No collections recorded</p>
//                 ) : (
//                   <>
//                     <table className="collections-table">
//                       <thead>
//                         <tr>
//                           <th>Method</th>
//                           <th>Amount</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {tempCollections.map((collection, index) => (
//                           <tr key={index}>
//                             <td>
//                               <span className={`collection-method ${collection.method.toLowerCase()}`}>
//                                 {collection.method}
//                               </span>
//                             </td>
//                             <td>{formatCurrency(collection.amount)}</td>
//                             <td>
//                               <button 
//                                 onClick={() => removeTempCollection(index)}
//                                 className="btn-remove-small"
//                                 title="Remove collection"
//                               >
//                                 <i className="fas fa-trash"></i>
//                               </button>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                     <div className="collection-total">
//                       <span>Total Collected:</span>
//                       <strong>{formatCurrency(tempCollections.reduce((sum, col) => sum + col.amount, 0))}</strong>
//                     </div>
//                   </>
//                 )}
//               </div>
//             </div>
            
//             <div className="modal-footer">
//               <button 
//                 onClick={() => {
//                   setTempCollections([]);
//                   ToastService.info('Collections cleared');
//                 }}
//                 className="btn-secondary"
//                 disabled={tempCollections.length === 0}
//               >
//                 <i className="fas fa-trash"></i> Clear All
//               </button>
//               <button onClick={confirmCollections} className="btn-collection">
//                 <i className="fas fa-check"></i> Confirm Collections
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CreateSale;

// CreateSale.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import SaleService from '../../services/SaleService';
import RouteService from '../../services/routeService';
import StockService from '../../services/stockService';
import ShiftService from '../../services/shiftService';
import ToastService from '../../services/toastService';
import AuthService from '../../services/authService';
import './CreateSale.css';

import { usePrinter } from '../../context/PrinterContext';
import EscPosEncoder from 'esc-pos-encoder';

const CreateSale = () => {
  const navigate = useNavigate();
  const { characteristic } = usePrinter();
  // State variables
  const [loading, setLoading] = useState({
    customers: true,
    routes: true,
    categories: true,
    products: true
  });
  const [customers, setCustomers] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [saleData, setSaleData] = useState({
    customerId: '',
    routeId: '',
    inventoryId: '',
    products: [],
    paymentMethods: [],
    productreturnData: null
  });
  const [currentProduct, setCurrentProduct] = useState({
    categoryId: '',
    productId: '',
    stockId: null,
    quantity: 1,
    pricePerUnit: 0,
    availableStock: 0,
    productName: '',
    unit: ''
  });
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [outstandingBalance, setOutstandingBalance] = useState(0);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showCollectionModal, setShowCollectionModal] = useState(false);
  const [tempPayments, setTempPayments] = useState([]);
  const [tempCollections, setTempCollections] = useState([]);
  const [paymentInput, setPaymentInput] = useState({
    method: 'CASH',
    amount: '',
    chequeNumber: '',
    bank: '',
    reference: ''
  });
  const [collectionInput, setCollectionInput] = useState({
    method: 'CASH',
    amount: '',
    chequeNumber: '',
    bank: '',
    reference: ''
  });
  const [returnAmount, setReturnAmount] = useState('');
  const [cartItems, setCartItems] = useState([]);
  const [processingSale, setProcessingSale] = useState(false);
  const [pollingInterval, setPollingInterval] = useState(null);
  const [optimisticStockUpdates, setOptimisticStockUpdates] = useState({});

  // Initialize data
  useEffect(() => {
    if (!AuthService.isAuthenticated()) {
      navigate('/login');
      return;
    }
    initializeSale();
    
    // Start polling for stock updates every 30 seconds
    const interval = setInterval(() => {
      if (saleData.inventoryId) {
        refreshStockData();
      }
    }, 30000);
    
    setPollingInterval(interval);
    
    // Cleanup on unmount
    return () => {
      if (interval) clearInterval(interval);
      if (pollingInterval) clearInterval(pollingInterval);
    };
  }, [navigate]);

  const initializeSale = async () => {
    try {
      setLoading({ customers: true, routes: true, categories: true, products: true });
      
      // Get current shift info
      ShiftService.initializeShift();
      const activeRouteId = ShiftService.getActiveRouteId();
      const activeInventoryId = ShiftService.getActiveInventoryId();
      
      if (!activeRouteId || !activeInventoryId) {
        ToastService.error('Please start a shift first');
        navigate('/shift');
        return;
      }

      // Set initial sale data
      setSaleData(prev => ({
        ...prev,
        routeId: activeRouteId,
        inventoryId: activeInventoryId
      }));

      // Load data sequentially
      await loadInvoiceNumber();
      await loadRoutes();
      await loadCustomers(activeRouteId);
      await loadStockAndProducts(activeInventoryId);
      
    } catch (error) {
      ToastService.error('Failed to initialize sale: ' + (error.message || 'Network error'));
      console.error('Initialize sale error:', error);
    } finally {
      setLoading({ customers: false, routes: false, categories: false, products: false });
    }
  };

  const loadCustomers = async (routeId) => {
    try {
      const customersData = await SaleService.getCustomersByRoute(routeId);
      const customersArray = Array.isArray(customersData) ? customersData : 
                           customersData.data ? customersData.data : [];
      setCustomers(customersArray);
      
      // Pre-select first customer if available
      if (customersArray.length > 0) {
        const firstCustomer = customersArray[0];
        setSaleData(prev => ({ ...prev, customerId: firstCustomer.id }));
        await loadCustomerCreditBalance(firstCustomer.id, routeId);
      }
    } catch (error) {
      ToastService.error('Failed to load customers');
      console.error('Load customers error:', error);
    }
  };

  const loadRoutes = async () => {
    try {
      const routesData = await SaleService.getAvailableRoutes();
      const routesArray = Array.isArray(routesData) ? routesData : 
                         routesData.data ? routesData.data : [];
      setRoutes(routesArray);
    } catch (error) {
      ToastService.error('Failed to load routes');
      console.error('Load routes error:', error);
    }
  };

  const loadInvoiceNumber = async () => {
    try {
      const invoiceData = await SaleService.getInvoiceNumber();
      setInvoiceNumber(invoiceData.invoiceNumber || invoiceData.data?.invoiceNumber || `INV-${Date.now()}`);
    } catch (error) {
      setInvoiceNumber(`INV-${Date.now()}`);
      console.error('Load invoice error:', error);
    }
  };

  const loadStockAndProducts = async (inventoryId) => {
    try {
      // Load stock data which includes product information
      const stockResponse = await StockService.getStockByInventoryNew(inventoryId);
      let stockList = [];
      
      if (Array.isArray(stockResponse)) {
        stockList = stockResponse;
      } else if (stockResponse.data && Array.isArray(stockResponse.data)) {
        stockList = stockResponse.data;
      }
      
      // Process products and categories from NEW API response structure
      const categoryMap = new Map();
      const productsList = [];
      
      stockList.forEach(stockItem => {
        // Check for new response structure
        if (stockItem && stockItem.product && stockItem.product.category) {
          const category = stockItem.product.category;
          const product = stockItem.product;
          
          // Add category to map
          if (!categoryMap.has(category.id)) {
            categoryMap.set(category.id, {
              id: category.id,
              name: category.name
            });
          }
          
          // Apply optimistic updates if any
          const optimisticUpdate = optimisticStockUpdates[stockItem.id];
          const adjustedStock = optimisticUpdate ? 
            stockItem.qty - optimisticUpdate : 
            stockItem.qty;
          
          // Add to products list with NEW structure
          productsList.push({
            id: stockItem.id, // Stock ID for UI operations
            productId: product.id, // Product ID for API call
            stockId: stockItem.id, // Keep reference to stock ID
            name: product.name || 'Unknown Product',
            categoryId: category.id,
            categoryName: category.name,
            price: parseFloat(stockItem.pricePerUnit) || 0,
            availableStock: Math.max(0, adjustedStock),
            isActive: stockItem.isActive !== false && product.isActive !== false,
            inventoryId: stockItem.inventory?.id,
            sku: product.sku || 'N/A'
          });
        }
      });
      
      // Filter only active products
      const activeProducts = productsList.filter(product => product.isActive);
      
      setCategories(Array.from(categoryMap.values()));
      setProducts(activeProducts);
      setFilteredProducts(activeProducts);
      
    } catch (error) {
      ToastService.error('Failed to load products');
      console.error('Load products error:', error);
    }
  };

  const refreshStockData = async () => {
    try {
      if (saleData.inventoryId) {
        await loadStockAndProducts(saleData.inventoryId);
        console.log('Stock data refreshed via polling');
      }
    } catch (error) {
      console.error('Polling refresh error:', error);
    }
  };

  const loadCustomerCreditBalance = async (customerId, routeId) => {
    try {
      const balanceData = await SaleService.getCustomerCreditBalance(customerId, routeId);
      setOutstandingBalance(balanceData.balance || 0);
    } catch (error) {
      setOutstandingBalance(0);
      console.error('Load credit balance error:', error);
    }
  };

  const handleCustomerChange = async (customerId) => {
    setSaleData(prev => ({ ...prev, customerId }));
    await loadCustomerCreditBalance(customerId, saleData.routeId);
  };

  const handleRouteChange = async (routeId) => {
    setSaleData(prev => ({ ...prev, routeId }));
    await loadCustomers(routeId);
  };

  const handleCategoryChange = (categoryId) => {
    setCurrentProduct(prev => ({ 
      ...prev, 
      categoryId, 
      productId: '',
      stockId: null,
      productName: '',
      pricePerUnit: 0,
      availableStock: 0,
      unit: ''
    }));
    
    if (categoryId) {
      const filtered = products.filter(product => 
        product.categoryId && product.categoryId.toString() === categoryId.toString()
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(products);
    }
  };

  const handleProductChange = (productId) => {
    // productId here is actually the stock ID from the products list
    const product = products.find(p => p.id.toString() === productId.toString());
    if (product) {
      setCurrentProduct(prev => ({
        ...prev,
        productId: product.productId, // This is the actual Product ID for API
        stockId: product.id, // This is the Stock ID for UI operations
        productName: product.name,
        pricePerUnit: product.price,
        availableStock: product.availableStock,
        unit: 'units'
      }));
    }
  };

  const handleQuantityChange = (quantity) => {
    const qty = parseInt(quantity);
    setCurrentProduct(prev => ({ ...prev, quantity: Math.max(1, qty) }));
  };

  const handlePriceChange = (price) => {
    const priceVal = parseFloat(price);
    setCurrentProduct(prev => ({ ...prev, pricePerUnit: Math.max(0, priceVal) }));
  };

  const addProductToCart = () => {
    if (!currentProduct.productId || !currentProduct.categoryId) {
      ToastService.error('Please select a product');
      return;
    }

    if (currentProduct.quantity <= 0) {
      ToastService.error('Please enter a valid quantity');
      return;
    }

    // Find product by stock ID (which is what's stored in products list)
    const product = products.find(p => p.id.toString() === currentProduct.stockId?.toString());
    if (!product) {
      ToastService.error('Product not found');
      return;
    }

    // Check stock with optimistic updates
    if (currentProduct.quantity > product.availableStock) {
      ToastService.error(`Only ${product.availableStock} units available`);
      return;
    }

    // Apply optimistic stock update - using product.id which is stockId
    const updatedOptimisticUpdates = {
      ...optimisticStockUpdates,
      [product.id]: (optimisticStockUpdates[product.id] || 0) + currentProduct.quantity
    };
    setOptimisticStockUpdates(updatedOptimisticUpdates);

    // Update products list with optimistic stock
    const updatedProducts = products.map(p => 
      p.id === product.id 
        ? { ...p, availableStock: p.availableStock - currentProduct.quantity }
        : p
    );
    
    setProducts(updatedProducts);
    
    // Update filtered products
    if (currentProduct.categoryId) {
      const updatedFiltered = filteredProducts.map(p =>
        p.id === product.id
          ? { ...p, availableStock: p.availableStock - currentProduct.quantity }
          : p
      );
      setFilteredProducts(updatedFiltered);
    }

    const newItem = {
      id: product.id, // Stock ID for UI operations
      productId: product.productId, // Product ID for API call
      stockId: product.id, // Keep reference to stock ID
      name: product.name,
      pricePerUnit: currentProduct.pricePerUnit,
      quantity: currentProduct.quantity,
      total: currentProduct.pricePerUnit * currentProduct.quantity,
      type: 'sale',
      categoryId: product.categoryId,
      categoryName: product.categoryName
    };

    setCartItems(prev => [...prev, newItem]);
    
    // Update sale data products - IMPORTANT: Use productId (Product model ID) for API
    setSaleData(prev => ({
      ...prev,
      products: [...prev.products, {
        productId: product.productId, // This should be Product ID from Product model
        pricePerUnit: currentProduct.pricePerUnit,
        qty: currentProduct.quantity,
        name: product.name,
        categoryName: product.categoryName
      }]
    }));

    // Reset current product
    setCurrentProduct({
      categoryId: '',
      productId: '',
      stockId: null,
      quantity: 1,
      pricePerUnit: 0,
      availableStock: 0,
      productName: '',
      unit: ''
    });
    
    setFilteredProducts(updatedProducts.filter(p => p.isActive));

    ToastService.success('Product added to cart');
  };

  const addReturnToCart = () => {
    const returnAmt = parseFloat(returnAmount);
    if (isNaN(returnAmt) || returnAmt <= 0) {
      ToastService.error('Please enter a valid return amount');
      return;
    }

    // Check if return amount is reasonable
    const saleTotal = cartItems
      .filter(item => item.type === 'sale')
      .reduce((sum, item) => sum + item.total, 0);
    
    if (returnAmt > saleTotal) {
      ToastService.error('Return amount cannot exceed total sale amount');
      return;
    }

    const returnItem = {
      id: `return_${Date.now()}`,
      amount: returnAmt,
      type: 'return',
      name: 'Sale Return (Deduction)'
    };

    setCartItems(prev => [...prev, returnItem]);
    setReturnAmount('');
    
    // Update sale data return
    setSaleData(prev => ({
      ...prev,
      productreturnData: { amount: returnAmt }
    }));

    ToastService.success('Return added to cart');
  };

  const removeCartItem = (index) => {
    const newCartItems = [...cartItems];
    const removedItem = newCartItems.splice(index, 1)[0];
    
    // If it's a sale item, restore optimistic stock
    if (removedItem.type === 'sale') {
      const updatedOptimisticUpdates = { ...optimisticStockUpdates };
      if (updatedOptimisticUpdates[removedItem.id]) {
        updatedOptimisticUpdates[removedItem.id] -= removedItem.quantity;
        if (updatedOptimisticUpdates[removedItem.id] <= 0) {
          delete updatedOptimisticUpdates[removedItem.id];
        }
      }
      setOptimisticStockUpdates(updatedOptimisticUpdates);
      
      // Restore stock in UI
      const updatedProducts = products.map(p => 
        p.id === removedItem.id 
          ? { ...p, availableStock: p.availableStock + removedItem.quantity }
          : p
      );
      
      setProducts(updatedProducts);
      
      if (currentProduct.categoryId) {
        const updatedFiltered = filteredProducts.map(p =>
          p.id === removedItem.id
            ? { ...p, availableStock: p.availableStock + removedItem.quantity }
            : p
        );
        setFilteredProducts(updatedFiltered);
      }
    }
    
    setCartItems(newCartItems);
    
    // Update sale data
    if (removedItem.type === 'sale') {
      setSaleData(prev => ({
        ...prev,
        products: prev.products.filter((_, i) => i !== index)
      }));
    } else if (removedItem.type === 'return') {
      setSaleData(prev => ({
        ...prev,
        productreturnData: null
      }));
    }
    
    ToastService.info('Item removed from cart');
  };

  // Calculate totals
  const calculateTotals = useCallback(() => {
    const subTotal = cartItems
      .filter(item => item.type === 'sale')
      .reduce((sum, item) => sum + (item.pricePerUnit * item.quantity), 0);
    
    const returns = cartItems
      .filter(item => item.type === 'return')
      .reduce((sum, item) => sum + item.amount, 0);
    
    const netTotal = subTotal - returns;
    const paidAmount = saleData.paymentMethods.reduce((sum, payment) => sum + (payment.amount || 0), 0);
    const remainingBalance = Math.max(0, netTotal - paidAmount);
    const collectedAmount = tempCollections.reduce((sum, col) => sum + col.amount, 0);
    const newOutstandingBalance = Math.max(0, outstandingBalance - collectedAmount);
    
    return {
      subTotal,
      returns,
      netTotal,
      paidAmount,
      remainingBalance,
      collectedAmount,
      newOutstandingBalance,
      isFullyPaid: remainingBalance <= 0,
      changeDue: Math.abs(Math.min(0, netTotal - paidAmount))
    };
  }, [cartItems, saleData.paymentMethods, tempCollections, outstandingBalance]);

  const totals = calculateTotals();

  const openPaymentModal = () => {
    if (cartItems.length === 0) {
      ToastService.error('Please add items to cart first');
      return;
    }
    
    if (!saleData.customerId) {
      ToastService.error('Please select a customer');
      return;
    }
    
    setTempPayments(saleData.paymentMethods);
    setShowPaymentModal(true);
  };

  const openCollectionModal = () => {
    if (!saleData.customerId) {
      ToastService.error('Please select a customer');
      return;
    }
    
    if (outstandingBalance <= 0) {
      ToastService.info('Customer has no outstanding balance');
      return;
    }
    
    setCollectionInput(prev => ({ ...prev, amount: outstandingBalance.toFixed(2) }));
    setTempCollections([]);
    setShowCollectionModal(true);
  };

  const addPayment = () => {
    const amount = parseFloat(paymentInput.amount);
    if (isNaN(amount) || amount <= 0) {
      ToastService.error('Please enter a valid amount');
      return;
    }

    const totals = calculateTotals();
    const existingPayments = tempPayments.reduce((sum, p) => sum + p.amount, 0);
    const remainingBalance = totals.netTotal - existingPayments;
    
    if (amount > remainingBalance && paymentInput.method !== 'CREDIT') {
      ToastService.error(`Payment amount exceeds remaining balance of Rs. ${remainingBalance.toFixed(2)}`);
      return;
    }

    if (paymentInput.method === 'CREDIT') {
      const newCreditBalance = outstandingBalance + amount;
      // Check credit limit if needed
    }

    const newPayment = {
      method: paymentInput.method,
      amount: amount
    };

    // Add additional details for specific payment methods
    if (paymentInput.method === 'CHEQUE') {
      if (!paymentInput.chequeNumber || !paymentInput.bank) {
        ToastService.error('Cheque number and bank are required');
        return;
      }
      newPayment.chequeNumber = paymentInput.chequeNumber;
      newPayment.bank = paymentInput.bank;
    }

    if (paymentInput.method === 'BANK_TRANSFER') {
      if (!paymentInput.reference) {
        ToastService.error('Reference number is required');
        return;
      }
      newPayment.reference = paymentInput.reference;
    }

    setTempPayments(prev => [...prev, newPayment]);
    
    // Reset payment input
    setPaymentInput({
      method: 'CASH',
      amount: '',
      chequeNumber: '',
      bank: '',
      reference: ''
    });

    ToastService.success('Payment added');
  };

  const addCollectionPayment = () => {
    const amount = parseFloat(collectionInput.amount);
    if (isNaN(amount) || amount <= 0) {
      ToastService.error('Please enter a valid amount');
      return;
    }

    const totalCollected = tempCollections.reduce((sum, col) => sum + col.amount, 0);
    const remainingDebt = outstandingBalance - totalCollected;
    
    if (amount > remainingDebt) {
      ToastService.error(`Collection amount cannot exceed remaining debt of Rs. ${remainingDebt.toFixed(2)}`);
      return;
    }

    const newCollection = {
      method: collectionInput.method,
      amount: amount
    };

    // Add additional details for specific payment methods
    if (collectionInput.method === 'CHEQUE') {
      if (!collectionInput.chequeNumber || !collectionInput.bank) {
        ToastService.error('Cheque number and bank are required');
        return;
      }
      newCollection.chequeNumber = collectionInput.chequeNumber;
      newCollection.bank = collectionInput.bank;
    }

    if (collectionInput.method === 'BANK_TRANSFER') {
      if (!collectionInput.reference) {
        ToastService.error('Reference number is required');
        return;
      }
      newCollection.reference = collectionInput.reference;
    }

    setTempCollections(prev => [...prev, newCollection]);
    
    // Update collection input amount for next entry
    const newRemainingDebt = Math.max(0, remainingDebt - amount);
    setCollectionInput(prev => ({ 
      ...prev, 
      amount: newRemainingDebt.toFixed(2),
      chequeNumber: '',
      bank: '',
      reference: ''
    }));

    ToastService.success('Collection payment added');
  };

  const confirmPayments = () => {
    if (tempPayments.length === 0 && totals.netTotal > 0) {
      ToastService.error('Please add at least one payment method');
      return;
    }

    // Validate payment methods
    const totalPaid = tempPayments.reduce((sum, p) => sum + p.amount, 0);
    const remaining = totals.netTotal - totalPaid;
    
    if (remaining > 0) {
      ToastService.error(`Net total must be fully covered by payments. Remaining: Rs. ${remaining.toFixed(2)}`);
      return;
    }

    setSaleData(prev => ({
      ...prev,
      paymentMethods: tempPayments
    }));
    
    setShowPaymentModal(false);
    ToastService.success('Payments confirmed');
  };

  const confirmCollections = async () => {
    if (tempCollections.length === 0) {
      ToastService.error('Please add at least one collection payment');
      return;
    }

    try {
      // Prepare collection data
      const collectionData = {
        customerId: saleData.customerId,
        routeId: saleData.routeId,
        payments: tempCollections.map(collection => ({
          amount: collection.amount,
          method: collection.method,
          ...(collection.chequeNumber && { chequeNumber: collection.chequeNumber }),
          ...(collection.bank && { bank: collection.bank }),
          ...(collection.reference && { reference: collection.reference })
        }))
      };
      
      // Process debt collection
      await SaleService.processDebtCollection(collectionData);
      
      // Update outstanding balance
      const totalCollected = tempCollections.reduce((sum, col) => sum + col.amount, 0);
      const newBalance = Math.max(0, outstandingBalance - totalCollected);
      setOutstandingBalance(newBalance);
      
      setShowCollectionModal(false);
      setTempCollections([]);
      ToastService.success('Collections processed successfully');
      
    } catch (error) {
      ToastService.error('Failed to process collections: ' + (error.message || 'Network error'));
      console.error('Process collections error:', error);
    }
  };

  const removeTempPayment = (index) => {
    const newPayments = [...tempPayments];
    newPayments.splice(index, 1);
    setTempPayments(newPayments);
    ToastService.info('Payment removed');
  };

  const removeTempCollection = (index) => {
    const newCollections = [...tempCollections];
    newCollections.splice(index, 1);
    setTempCollections(newCollections);
    
    // Update collection input amount
    const totalCollected = newCollections.reduce((sum, col) => sum + col.amount, 0);
    const remainingBalance = Math.max(0, outstandingBalance - totalCollected);
    setCollectionInput(prev => ({ ...prev, amount: remainingBalance.toFixed(2) }));
    
    ToastService.info('Collection removed');
  };

  const handleCompleteSale = async () => {
    if (!totals.isFullyPaid) {
      ToastService.error('Sale must be fully paid before completing');
      return;
    }
    if (saleData.products.length === 0) {
      ToastService.error('Please add at least one product');
      return;
    }
    if (!saleData.customerId || !saleData.routeId || !saleData.inventoryId) {
      ToastService.error('Please fill all required fields');
      return;
    }

    // Validate sale data using SaleService
    const validation = SaleService.validateSaleData(saleData);
    if (!validation.isValid) {
      ToastService.error(validation.errors[0]);
      return;
    }

    try {
      setProcessingSale(true);
      
      // Prepare sale data - REMOVED categoryId from products
      const preparedData = {
        customerId: parseInt(saleData.customerId),
        routeId: parseInt(saleData.routeId),
        inventoryId: parseInt(saleData.inventoryId),
        products: saleData.products.map(product => ({
          productId: parseInt(product.productId), // Only productId needed
          qty: parseInt(product.qty),
          pricePerUnit: parseFloat(product.pricePerUnit)
        })),
        paymentMethods: saleData.paymentMethods.map(payment => ({
          method: payment.method,
          amount: parseFloat(payment.amount),
          ...(payment.chequeNumber && { chequeNumber: payment.chequeNumber }),
          ...(payment.bank && { bank: payment.bank }),
          ...(payment.reference && { reference: payment.reference })
        })),
        productreturnData: saleData.productreturnData ? {
          amount: parseFloat(saleData.productreturnData.amount)
        } : null
      };
      
      // Create sale
      const result = await SaleService.createSale(preparedData);
      
      console.log('Sale result:', result);
      console.log('Characteristic available:', characteristic ? 'Yes' : 'No');
      
      // AUTOMATIC PRINTING with actual sales data
      if (characteristic && characteristic.writeValue) {
        try {
          console.log('Attempting to print receipt...');
          
          // Generate receipt with actual sales data
          const receiptData = await generateReceiptWithActualData({
            saleResult: result,
            cartItems: cartItems.filter(item => item.type === 'sale'),
            totals: calculateTotals(),
            saleData: saleData,
            customers: customers,
            routes: routes,
            currentUser: AuthService.getCurrentUser()
          });
          
          console.log('Receipt generated, size:', receiptData.byteLength, 'bytes');
          
          // Write to printer in chunks
          // const CHUNK_SIZE = 480;
          // const buffer = receiptData;
          // const totalBytes = buffer.byteLength;
          // let offset = 0;

          const CHUNK_SIZE = 100; 
    const totalBytes = receiptData.byteLength;
    let offset = 0;
          
          // console.log(`Writing receipt (${totalBytes} bytes)...`);
          
          // while (offset < totalBytes) {
          //   const chunkSize = Math.min(CHUNK_SIZE, totalBytes - offset);
          //   const chunk = buffer.slice(offset, offset + chunkSize);
            
          //   await characteristic.writeValue(chunk);
          //   console.log(`Written chunk: ${chunkSize} bytes`);
            
          //   await new Promise(resolve => setTimeout(resolve, 50));
            
          //   offset += chunkSize;
          // }
          
          // console.log('Receipt printed successfully!');
          // ToastService.success('Sale completed and receipt printed!');
          console.log(`Writing receipt (${totalBytes} bytes) in ${CHUNK_SIZE} byte chunks...`);
    
    while (offset < totalBytes) {
      const chunkSize = Math.min(CHUNK_SIZE, totalBytes - offset);
      const chunk = receiptData.slice(offset, offset + chunkSize);
      
      // Send the chunk
      await characteristic.writeValue(chunk);
      
      // INCREASED DELAY: Crucial for mobile printers to prevent data loss
      // 100ms is the "Goldilocks" zone for most 58mm thermal printers
      await new Promise(resolve => setTimeout(resolve, 100));
      
      offset += chunkSize;
    }
    
    console.log('Receipt printed successfully!');
    ToastService.success('Sale completed and receipt printed!');
          
        } catch (printError) {
          // console.error('Printing failed:', printError);
          // ToastService.success('Sale completed, but receipt could not be printed.');
          console.error('Printing failed:', printError);
    ToastService.success('Sale completed, but receipt could not be printed.');
        }
      } else {
        console.warn('No printer connected or writeValue not available');
        ToastService.success('Sale completed successfully! (No printer connected)');
      }

      // Cleanup & Refresh
      setOptimisticStockUpdates({});
      resetSaleForm();
      
      // Load fresh data after a short delay
      setTimeout(async () => {
        try {
          await loadInvoiceNumber();
          if (saleData.inventoryId) {
            await loadStockAndProducts(saleData.inventoryId);
          }
        } catch (refreshError) {
          console.error('Failed to refresh data:', refreshError);
        }
      }, 500);
      
    } catch (error) {
      console.error('Sale completion failed:', error);
      ToastService.error('Failed to complete sale: ' + (error.message || 'Network error'));
      
      // Refresh stock data
      if (saleData.inventoryId) {
        try {
          await loadStockAndProducts(saleData.inventoryId);
        } catch (refreshError) {
          console.error('Failed to refresh stock:', refreshError);
        }
      }
    } finally {
      setProcessingSale(false);
    }
  };
// Replace the generateReceiptWithActualData function with this corrected version:
// const generateReceiptWithActualData = async ({ 
//   saleResult, 
//   cartItems, 
//   totals, 
//   saleData, 
//   customers, 
//   routes,
//   currentUser 
// }) => {
//   const encoder = new EscPosEncoder();
  
//   // Get actual data from the sale
//   const customer = customers.find(c => c.id.toString() === saleData.customerId.toString());
//   const route = routes.find(r => r.id.toString() === saleData.routeId.toString());
  
//   // Get invoice number from the actual sale result
//   const invoiceNum = saleResult.invoiceNumber || saleResult.data?.invoiceNumber || invoiceNumber || `INV-${Date.now()}`;
  
//   // Get current date and time
//   const now = new Date();
//   const currentTime = now.toLocaleTimeString('en-US', { 
//     hour: '2-digit', 
//     minute: '2-digit',
//     hour12: true 
//   });
//   const currentDate = now.toLocaleDateString('en-GB');
  
//   // Business information
//   const businessName = "Sayul Redistributions";
//   const businessAddress = "NO 244/2/A.Makola, North, Makola";
//   const businessPhone = "Tel: +94 77 222 2700";

//   // Customer actual data
//   const customerName = customer?.name || "Cash Customer";
//   const customerCode = customer?.code || "N/A";
  
//   // Sales rep info
//   const salesRep = currentUser?.firstName ? `${currentUser.firstName} ${currentUser.lastName || ''}`.trim() : "Sales Rep";
  
//   // Route info
//   const routeName = route?.name || "Route";
  
//   // Inventory info - you might need to get this from ShiftService
//   const activeInventoryId = ShiftService.getActiveInventoryId();
//   const inventory = `INV-${activeInventoryId}` || "Inventory";

//   // Actual product items from cart
//   const saleProducts = cartItems.filter(item => item.type === 'sale');
  
//   // Actual payments from sale data
//   const actualPayments = saleData.paymentMethods || [];
  
//   // Actual totals
//   const subTotal = totals.subTotal || 0;
//   const returns = totals.returns || 0;
//   const netTotal = totals.netTotal || 0;
//   const paidAmount = totals.paidAmount || 0;
//   const remainingBalance = totals.remainingBalance || 0;
//   const changeDue = totals.changeDue || 0;
  
//   // Debug log to check data
//   console.log('Receipt Data Debug:', {
//     invoiceNum,
//     customerName,
//     salesRep,
//     routeName,
//     inventory,
//     saleProductsCount: saleProducts.length,
//     saleProducts,
//     actualPayments,
//     totals: { subTotal, returns, netTotal, paidAmount, remainingBalance, changeDue }
//   });

//   // Build the receipt with ACTUAL data
//   const receipt = encoder
//     .initialize()
//     .codepage('cp858')
    
//     // ==================== BUSINESS HEADER ====================
//     .align('center')
//         .size(2, 2)
//         .bold(true)
//         .line(businessName)
//         .line(' ')
//         .size(1, 1)
//         .bold(false)
//         .line(businessAddress)
//         .line(businessPhone)
//         .line(' ')
//         .line('='.repeat(42))
    
//     // ==================== INVOICE DETAILS ====================
//   .align('left')
//         .bold(true)
//         .line('INVOICE DETAILS')
//         .bold(false)
//         .line('─'.repeat(32))
//         .line(`Invoice # : ${invoiceNum}`)
//         .line(`Date/Time : ${currentDate} ${currentTime}`)
//         .line(`Customer  : ${customerName}`)
//         .line(`Cust Code : ${customerCode}`)
//         .line(`Sales Rep : ${salesRep}`)
//         .line(`Route     : ${route}`)
//         .line(`Inventory : ${inventory}`)
//         .line('='.repeat(42))
    
//     // ==================== PRODUCTS SECTION ====================
//    .align('center')
//         .bold(true)
//         .line('PRODUCTS')
//         .bold(false)
//         .line('─'.repeat(42))
        
//         // Table Header
//         .align('center')
//         .bold(true)
//         .line('   Category    Product        Qty   Price')
//         .bold(false)
//         .line('─'.repeat(42));
  
//   // Check if we have products

    
//     // Add ACTUAL products
//     saleProducts.forEach(item => {
//         const category = item.category.padEnd(11);
//         const product = item.name.substring(0, 14).padEnd(15);
//         const qty = item.qty.toString().padStart(3);
//         const price = item.price.toFixed(2).padStart(8);
        
//         receipt.line(`${category}${product}${qty}${price}`);
//       });
      
//       receipt.line('─'.repeat(42));
      
  
//   // ==================== TOTALS SECTION ====================
//   receipt
//     .align('right')
//     .line(`Sub Total: ${subTotal.toFixed(2).padStart(12)}`);
  
//   // Returns (if any)
//   if (returns > 0) {
//     receipt.line(`Returns  : -${returns.toFixed(2).padStart(12)}`);
//     receipt.line('─'.repeat(48));
//   }
  
//   // ==================== PAYMENT METHODS ====================
//   if (actualPayments.length > 0) {
//     receipt
//       .align('left')
//       .bold(true)
//       .line('PAYMENT METHODS')
//       .bold(false)
//       .line('─'.repeat(48));
    
//     actualPayments.forEach((payment, index) => {
//       const method = (payment.method || 'CASH').replace('_', ' ');
//       const methodDisplay = `${index + 1}. ${method}`.padEnd(20);
//       const amount = (payment.amount || 0).toFixed(2).padStart(15);
//       receipt.line(`${methodDisplay}${amount}`);
      
//       // Add payment details if available
//       if (payment.chequeNumber) {
//         receipt.line(`  Cheque #: ${payment.chequeNumber}`);
//       }
//       if (payment.bank) {
//         receipt.line(`  Bank: ${payment.bank}`);
//       }
//       if (payment.reference) {
//         receipt.line(`  Ref: ${payment.reference}`);
//       }
//     });
    
//     receipt.line('─'.repeat(48));
//   }
  
//   // ==================== FINAL SUMMARY ====================
//       receipt
//         .align('right')
//         .bold(true)
//         .size('double')
//         .line('─'.repeat(32))
//         .line(`TOTAL: Rs.${netTotal.toFixed(2).padStart(10)}`)
//         .size('normal')
//         .bold(false)
//         .line('─'.repeat(42));
  
//  receipt
//         .align('left')
//         .line(`Paid Amount: ${paidAmount.toFixed(2).padStart(10)}`);
      
//       if (remainingBalance > 0) {
//         receipt.line(`Balance Due: ${remainingBalance.toFixed(2).padStart(10)}`);
//       } else if (changeDue > 0) {
//         receipt.line(`Change Due : ${changeDue.toFixed(2).padStart(10)}`);
//       } else {
//         receipt.line(`Payment    : FULLY PAID`);
//       }
      
  
//   // ==================== FOOTER ====================
//  receipt
//         .line('='.repeat(42))
//         .line(' ')
//         .align('center')
//         .bold(true)
//         .line('THANK YOU!')
//         .bold(false)
//         .line('We value your business')
//         .line('Please visit again')
//         .newline()
//         .newline()
//         .cut('partial');
  
//   // ENCODE the receipt
//   const encodedData = receipt.encode();
  
//   console.log('Receipt generated successfully, size:', encodedData.byteLength, 'bytes');
//   return encodedData;
// };

// const generateReceiptWithActualData = async ({ 
//   saleResult, 
//   cartItems, 
//   totals, 
//   customers, 
//   routes,
//   currentUser 
// }) => {
//   const encoder = new EscPosEncoder();
  
//   // Get invoice number from the actual sale result
//   const invoiceNum = saleResult.invoiceNum || saleResult.data?.invoiceNumber || `INV-${Date.now()}`;
  
//   // Get current date and time
//   const now = new Date();
//   const currentTime = now.toLocaleTimeString('en-US', { 
//     hour: '2-digit', 
//     minute: '2-digit',
//     hour12: true 
//   });
//   const currentDate = now.toLocaleDateString('en-GB');
  
//   // Business information
//   const businessName = "Sayul Redistributions";
//   const businessAddress = "NO 244/2/A.Makola, North, Makola";
//   const businessPhone = "Tel: +94 77 222 2700";

//   // Extract data directly from saleResult
//   const customerName = customers.name || "Cash Customer";
//   const salesRep = saleResult.salesRep || (currentUser?.firstName ? `${currentUser.firstName} ${currentUser.lastName || ''}`.trim() : "Sales Rep");
//   const routeName = routes || "Route";
//   const inventory = saleResult.inventory || "Inventory";
  
//   // Get actual product items from saleResult
//   const saleProducts = saleResult.saleProducts || [];
//   const saleProductsCount = saleResult.saleProductsCount || saleProducts.length;
  
//   // Get actual payments from saleResult
//   const actualPayments = saleResult.actualPayments || [];
  
//   // Get actual totals from saleResult
//   const actualTotals = saleResult.totals || {};
//   const subTotal = actualTotals.subTotal || 0;
//   const returns = actualTotals.returns || 0;
//   const netTotal = actualTotals.netTotal || 0;
//   const paidAmount = actualTotals.paidAmount || 0;
//   const remainingBalance = actualTotals.remainingBalance || 0;
//   const changeDue = actualTotals.changeDue || 0;
  
//   // Debug log to check data
//   console.log('Receipt Data Debug:', {
//     invoiceNum,
//     customerName,
//     salesRep,
//     routeName,
//     inventory,
//     saleProductsCount,
//     saleProducts,
//     actualPayments,
//     totals: totals
//   });

//   // Build the receipt with ACTUAL data
//   const receipt = encoder
//     .initialize()
//     .codepage('cp858')
    
//     // ==================== BUSINESS HEADER ====================
//     .align('center')
//     .size(2, 2)
//     .bold(true)
//     .line(businessName)
//     .line(' ')
//     .size(1, 1)
//     .bold(false)
//     .line(businessAddress)
//     .line(businessPhone)
//     .line(' ')
//     .line('='.repeat(42))
    
//     // ==================== INVOICE DETAILS ====================
//     .align('left')
//     .bold(true)
//     .line('INVOICE DETAILS')
//     .bold(false)
//     .line('─'.repeat(32))
//     .line(`Invoice # : ${invoiceNum}`)
//     .line(`Date/Time : ${currentDate} ${currentTime}`)
//     .line(`Customer  : ${customerName}`)
//     .line(`Sales Rep : ${salesRep}`)
//     .line(`Route     : ${routeName}`)
//     .line(`Inventory : ${inventory}`)
//     .line('='.repeat(42))
    
//     // ==================== PRODUCTS SECTION ====================
//     .align('center')
//     .bold(true)
//     .line('PRODUCTS')
//     .bold(false)
//     .line('─'.repeat(42));
  
//   // Check if we have products
//   if (saleProducts.length === 0) {
//     receipt
//       .align('center')
//       .line('No products')
//       .line('─'.repeat(42));
//   } else {
//     // Table Header
//     receipt
//       .align('left')
//       .bold(true)
//       .line('Product               Qty    Price    Total')
//       .bold(false)
//       .line('─'.repeat(42));
    
//     // Add ACTUAL products
//     saleProducts.forEach(item => {
//       const productName = item.name || 'Unknown Product';
//       const qty = item.quantity || item.qty || 0;
//       const pricePerUnit = item.pricePerUnit || item.price || 0;
//       const total = qty * pricePerUnit;
      
//       // Format product name (max 20 chars)
//       const formattedName = productName.substring(0, 20).padEnd(20);
//       const formattedQty = qty.toString().padStart(4);
//       const formattedPrice = pricePerUnit.toFixed(2).padStart(7);
//       const formattedTotal = total.toFixed(2).padStart(9);
      
//       receipt.line(`${formattedName}${formattedQty}${formattedPrice}${formattedTotal}`);
//     });
    
//     receipt.line('─'.repeat(42));
//   }
  
//   // ==================== TOTALS SECTION ====================
//   receipt
//     .align('right')
//     .line(`Sub Total: ${subTotal.toFixed(2).padStart(12)}`);
  
//   // Returns (if any)
//   if (returns > 0) {
//     receipt.line(`Returns  : -${returns.toFixed(2).padStart(12)}`);
//     receipt.line('─'.repeat(48));
//   }
  
//   receipt.line(`Net Total: ${netTotal.toFixed(2).padStart(12)}`);
//   receipt.line('─'.repeat(48));
  
//   // ==================== PAYMENT METHODS ====================
//   if (actualPayments.length > 0) {
//     receipt
//       .align('left')
//       .bold(true)
//       .line('PAYMENT METHODS')
//       .bold(false)
//       .line('─'.repeat(48));
    
//     actualPayments.forEach((payment, index) => {
//       const method = (payment.method || 'CASH').replace('_', ' ');
//       const methodDisplay = `${index + 1}. ${method}`.padEnd(20);
//       const amount = (payment.amount || 0).toFixed(2).padStart(15);
//       receipt.line(`${methodDisplay}${amount}`);
//     });
    
//     receipt.line('─'.repeat(48));
//   }
  
//   // ==================== FINAL SUMMARY ====================
//   receipt
//     .align('right')
//     .bold(true)
//     .size('double')
//     .line('─'.repeat(32))
//     .line(`TOTAL: Rs.${netTotal.toFixed(2).padStart(10)}`)
//     .size('normal')
//     .bold(false)
//     .line('─'.repeat(42));
  
//   receipt
//     .align('left')
//     .line(`Paid Amount: ${paidAmount.toFixed(2).padStart(10)}`);
  
//   if (remainingBalance > 0) {
//     receipt.line(`Balance Due: ${remainingBalance.toFixed(2).padStart(10)}`);
//   } else if (changeDue > 0) {
//     receipt.line(`Change Due : ${changeDue.toFixed(2).padStart(10)}`);
//   } else {
//     receipt.line(`Payment    : FULLY PAID`);
//   }
  
//   // ==================== FOOTER ====================
//   receipt
//     .line('='.repeat(42))
//     .line(' ')
//     .align('center')
//     .bold(true)
//     .line('THANK YOU!')
//     .bold(false)
//     .line('We value your business')
//     .line('Please visit again')
//     .newline()
//     .newline()
//     .cut('partial');
  
//   // ENCODE the receipt
//   const encodedData = receipt.encode();
  
//   console.log('Receipt generated successfully, size:', encodedData.byteLength, 'bytes');
//   return encodedData;
// };
 
  // const generateReceiptWithActualData = async ({ 
  //   saleResult, 
  //   cartItems, 
  //   totals, 
  //   saleData, 
  //   customers, 
  //   routes,
  //   currentUser 
  // }) => {
  //   const encoder = new EscPosEncoder();
    
  //   // Get actual data from the sale
  //   const customer = customers.find(c => c.id.toString() === saleData.customerId.toString());
  //   const route = routes.find(r => r.id.toString() === saleData.routeId.toString());
    
  //   // Invoice number from sale result or generated
  //   const invoiceNum = saleResult.invoiceNumber || saleResult.data?.invoiceNumber || invoiceNumber;
  //   const currentTime = new Date().toLocaleTimeString('en-US', { 
  //     hour: '2-digit', 
  //     minute: '2-digit',
  //     hour12: true 
  //   });
  //   const currentDate = new Date().toLocaleDateString('en-GB');
    
  //   // Business information
  //   const businessName = "  Sayul Redistributions";
  //   const businessAddress = "NO 244/2/A.Makola, North, Makola";
  //   const businessPhone = "Tel: +94 77 222 2700";
  
  //   // Customer actual data
  //   const customerName = customer?.name || "Cash Customer";

  //   const salesRep = currentUser?.firstName || "Sales Rep";
  //   const routeName = route?.name || "Route";
  //   const inventory = 'inventoryInfo.name';

  //   // Actual product items from cart
  //   const saleProducts = cartItems.filter(item => item.type === 'sale');
    
  //   // Actual payments from sale data
  //   const actualPayments = saleData.paymentMethods || [];
    
  //   // Actual totals
  //   const subTotal = totals.subTotal || 0;
  //   const returns = totals.returns || 0;
  //   const netTotal = totals.netTotal || 0;
  //   const paidAmount = totals.paidAmount || 0;
  //   const remainingBalance = totals.remainingBalance || 0;
  //   const changeDue = totals.changeDue || 0;

  //   // Build the receipt with ACTUAL data
  //   const receipt = encoder
  //     .initialize()
  //     .codepage('cp858')
      
  //     // ==================== BUSINESS HEADER ====================
  //     .align('center')
  //     .size(2, 2)
  //     .bold(true)
  //     .line(businessName)
  //     .size(1, 1)
  //     .bold(false)
  //     .line(businessAddress)
  //     .line(businessPhone)
  //     .line('='.repeat(42))
      
  //     // ==================== INVOICE DETAILS ====================
  //     .align('left')
  //     .bold(true)
  //     .line('INVOICE DETAILS')
  //     .bold(false)
  //     .line('─'.repeat(42))
  //     .line(`Invoice # : ${invoiceNum}`)
  //     .line(`Date/Time : ${currentDate} ${currentTime}`)
  //     .line(`Customer  : ${customerName.substring(0, 20)}`)
  //     .line(`Sales Rep : ${salesRep.substring(0, 15)}`)
  //     .line(`Route     : ${routeName.substring(0, 15)}`)
  //     .line(`Inventory : ${inventory.substring(0, 15)}`)
  //     .line('='.repeat(42))
      
  //     // ==================== PRODUCTS SECTION ====================
  //     .align('center')
  //     .bold(true)
  //     .line('PRODUCTS')
  //     .bold(false)
  //     .line('─'.repeat(42))
      
  //     // Table Header
  //     .align('center')
  //     .bold(true)
  //     .line('   Category    Product        Qty   Price')
  //     .bold(false)
  //     .line('─'.repeat(42));
    
  //   // Add ACTUAL products (limit to 10 items for receipt space)
  //   const displayProducts = saleProducts.slice(0, 10);
  //   displayProducts.forEach(item => {
  //     const category = (item.categoryName || 'GEN').substring(0, 11).padEnd(11);
  //     const product = (item.name || 'Item').substring(0, 14).padEnd(15);
  //     const qty = (item.quantity || 0).toString().padStart(3);
  //     const price = (item.pricePerUnit || 0).toFixed(2).padStart(8);
      
  //     receipt.line(`${category}${product}${qty}${price}`);
  //   });
    
  //   // If there were more items, show a summary
  //   if (saleProducts.length > 10) {
  //     receipt.line(`... and ${saleProducts.length - 10} more items`);
  //   }
    
  //   receipt.line('─'.repeat(42));
    
  //   // ==================== TOTALS ====================
  //   receipt
  //     .align('right')
  //     .line(`Sub Total: ${subTotal.toFixed(2).padStart(10)}`);
    
  //   // Returns (if any)
  //   if (returns > 0) {
  //     receipt.line(`Returns  : -${returns.toFixed(2).padStart(10)}`);
  //   }
    
  //   receipt.line('─'.repeat(42));
    
  //   // ==================== PAYMENT METHODS ====================
  //   if (actualPayments.length > 0) {
  //     receipt
  //       .align('left')
  //       .bold(true)
  //       .line('PAYMENT METHODS')
  //       .bold(false)
  //       .line('─'.repeat(42));
      
  //     actualPayments.forEach(payment => {
  //       const method = (payment.method || 'CASH').substring(0, 16).padEnd(16);
  //       const amount = (payment.amount || 0).toFixed(2).padStart(10);
  //       receipt.line(`${method}${amount}`);
  //     });
      
  //     receipt.line('─'.repeat(42));
  //   }
    
  //   // ==================== FINAL TOTAL ====================
  //   receipt
  //     .align('right')
  //     .bold(true)
  //     .size('double')
  //     .line('─'.repeat(42))
  //     .line(`TOTAL: Rs.${netTotal.toFixed(2).padStart(10)}`)
  //     .size('normal')
  //     .bold(false)
  //     .line('─'.repeat(42));
    
  //   // ==================== PAYMENT SUMMARY ====================
  //   receipt
  //     .align('left')
  //     .line(`Paid Amount: ${paidAmount.toFixed(2).padStart(10)}`);
    
  //   if (remainingBalance > 0) {
  //     receipt.line(`Balance Due: ${remainingBalance.toFixed(2).padStart(10)}`);
  //   } else if (changeDue > 0) {
  //     receipt.line(`Change Due : ${changeDue.toFixed(2).padStart(10)}`);
  //   } else {
  //     receipt.line(`Payment    : FULLY PAID`);
  //   }
    
  //   // ==================== FOOTER ====================
  //   receipt
  //     .line('='.repeat(42))
  //     .line(' ')
  //     .align('center')
  //     .bold(true)
  //     .line('THANK YOU!')
  //     .bold(false)
  //     .line('We value your business')
  //     .line('Please visit again')
  //     .line(' ')
  //     .size(1, 1)
  //     .line('software by @fidesm.dev | +94 75 718 0225')
  //     .newline()
  //     .cut('partial');
    
  //   // ENCODE the receipt
  //   const encodedData = receipt.encode();
    
  //   console.log('Receipt size:', encodedData.byteLength, 'bytes');
  //   return encodedData;
  // };
const generateReceiptWithActualData = async ({ 
  saleResult, 
  cartItems, 
  totals, 
  saleData, 
  customers, 
  routes,
  currentUser 
}) => {
  const encoder = new EscPosEncoder();
  
  // Get actual data from the sale
  const customer = customers.find(c => c.id.toString() === saleData.customerId.toString());
  const route = routes.find(r => r.id.toString() === saleData.routeId.toString());
  
  // Invoice number from sale result or generated
  const invoiceNum = saleResult.invoiceNumber || saleResult.data?.invoiceNumber || invoiceNumber;
  const currentTime = new Date().toLocaleTimeString('en-US', { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: true 
  });
  const currentDate = new Date().toLocaleDateString('en-GB');
  
  // Business information
  const businessName = "         Sayul Redistributions";
  const businessAddress =  "NO 244/2/A.Makola, North, Makola";
  const businessPhone = "Tel: +94 77 222 2700";

  // Customer actual data
  const customerName = customer?.name || "Cash Customer";

  const salesRep = currentUser?.firstName || "Sales Rep";
  const routeName = route?.name || "Route";
  const inventory = 'inventoryInfo.name';

  // Actual product items from cart
  const saleProducts = cartItems.filter(item => item.type === 'sale');
  
  // Actual payments from sale data
  const actualPayments = saleData.paymentMethods || [];
  
  // Actual totals
  const subTotal = totals.subTotal || 0;
  const returns = totals.returns || 0;
  const netTotal = totals.netTotal || 0;
  const paidAmount = totals.paidAmount || 0;
  const remainingBalance = totals.remainingBalance || 0;
  const changeDue = totals.changeDue || 0;

  // Build the receipt with ACTUAL data
  const receipt = encoder
    .initialize()
    .codepage('cp858')
    
    // ==================== BUSINESS HEADER ====================
    .align('center')
    .size(2, 2)
    .bold(true)
    .line(businessName)
    .size(1, 1)
    .bold(false)
    .line(businessAddress)
    .line(businessPhone)
    .line('='.repeat(42))
    
    // ==================== INVOICE DETAILS ====================
    .align('left')
    .bold(true)
    .line('INVOICE DETAILS')
    .bold(false)
    .line('='.repeat(42))
    .line(`Invoice # : ${invoiceNum}`)
    .line(`Date/Time : ${currentDate} ${currentTime}`)
    .line(`Customer  : ${customerName.substring(0, 20)}`)
    .line(`Sales Rep : ${salesRep.substring(0, 15)}`)
    .line(`Route     : ${routeName.substring(0, 15)}`)
    .line(`Inventory : ${inventory.substring(0, 15)}`)
    .line('='.repeat(42))
    
    // ==================== PRODUCTS SECTION ====================
    .align('center')
    .bold(true)
    .line('PRODUCTS')
    .bold(false)
    .line('='.repeat(42))
    
    // Table Header - UPDATED to show "Line Total" instead of just "Price"
    .align('center')
    .bold(true)
    .line('Category  Product        Qty Price')
    .bold(false)
    .line('='.repeat(42));
  
  // Print ALL sale products with line totals (quantity × price)
  saleProducts.forEach(item => {
    const quantity = item.quantity || 0;
    const unitPrice = item.pricePerUnit || 0;
    const lineTotal = quantity * unitPrice; // Calculate the actual line total
    
    const category = (item.categoryName || 'GEN').substring(0, 9).padEnd(9);
    const product = (item.name || 'Item').substring(0, 14).padEnd(14);
    const qty = quantity.toString().padStart(3);
    const total = lineTotal.toFixed(2).padStart(11); // Show line total instead of unit price
    
    receipt.line(`${category}${product}${qty}${total}`);
  });
  
  receipt.line('='.repeat(42));
  
  // ==================== TOTALS ====================
  receipt
    .align('right')
    .line(`Sub Total: ${subTotal.toFixed(2).padStart(10)}`);
  
  // Returns (if any)
  if (returns > 0) {
    receipt.line(`Returns  : -${returns.toFixed(2).padStart(10)}`);
  }
  
  receipt.line('='.repeat(42));
  
  // ==================== PAYMENT METHODS ====================
  if (actualPayments.length > 0) {
    receipt
      .align('left')
      .bold(true)
      .line('PAYMENT METHODS')
      .bold(false)
      .line('='.repeat(42));
    
    actualPayments.forEach(payment => {
      const method = (payment.method || 'CASH').substring(0, 16).padEnd(16);
      const amount = (payment.amount || 0).toFixed(2).padStart(10);
      receipt.line(`${method}${amount}`);
    });
    
    receipt.line('='.repeat(42));
  }
  
  // ==================== FINAL TOTAL ====================
  receipt
    .align('right')
    .bold(true)
    .size('double')
    .line('='.repeat(42))
    .line(`TOTAL: Rs.${netTotal.toFixed(2).padStart(10)}`)
    .size('normal')
    .bold(false)
    .line('='.repeat(42));
  
  // ==================== PAYMENT SUMMARY ====================
  receipt
    .align('left')
    .line(`Paid Amount: ${paidAmount.toFixed(2).padStart(10)}`);
  
  if (remainingBalance > 0) {
    receipt.line(`Balance Due: ${remainingBalance.toFixed(2).padStart(10)}`);
  } else if (changeDue > 0) {
    receipt.line(`Change Due : ${changeDue.toFixed(2).padStart(10)}`);
  }
  
  // ==================== FOOTER ====================
  receipt
    .line('='.repeat(42))
    .line(' ')
    .align('center')
    .bold(true)
    .line('THANK YOU!')
    .bold(false)
    .line('We value your business')
    .line('Please keep this receipt for your records')
    .line(' ')
    .size(1, 1)
    .line('software by @fidesm.dev | +94 75 718 0225')
    .newline()
    .cut('partial');
  
  // ENCODE the receipt
  const encodedData = receipt.encode();
  
  console.log('Receipt size:', encodedData.byteLength, 'bytes');
  console.log(`Printed ${saleProducts.length} products on receipt`);
  
  // Debug log to verify calculations
  if (saleProducts.length > 0) {
    const firstProduct = saleProducts[0];
    console.log('First product debug:', {
      name: firstProduct.name,
      quantity: firstProduct.quantity,
      unitPrice: firstProduct.pricePerUnit,
      calculatedLineTotal: firstProduct.quantity * firstProduct.pricePerUnit
    });
  }
  
  return encodedData;
};
  const resetSaleForm = () => {
    // Reset all state but keep route and inventory
    setSaleData(prev => ({
      ...prev, // Keep routeId and inventoryId
      customerId: '',
      products: [],
      paymentMethods: [],
      productreturnData: null
    }));
    
    setCartItems([]);
    setTempPayments([]);
    setTempCollections([]);
    setCurrentProduct({
      categoryId: '',
      productId: '',
      stockId: null,
      quantity: 1,
      pricePerUnit: 0,
      availableStock: 0,
      productName: '',
      unit: ''
    });
    
    setReturnAmount('');
    setPaymentInput({
      method: 'CASH',
      amount: '',
      chequeNumber: '',
      bank: '',
      reference: ''
    });
    
    // Reset outstanding balance
    setOutstandingBalance(0);
    
    // Reload customers for current route
    if (saleData.routeId) {
      loadCustomers(saleData.routeId);
    }
    
    ToastService.info('Form reset for next sale');
  };

  const handleCancelSale = () => {
    if (cartItems.length > 0 || saleData.paymentMethods.length > 0) {
      if (window.confirm('Are you sure you want to cancel this sale? All items and payments will be cleared.')) {
        // Clear optimistic updates
        setOptimisticStockUpdates({});
        
        // Refresh stock data
        if (saleData.inventoryId) {
          loadStockAndProducts(saleData.inventoryId);
        }
        
        resetSaleForm();
        ToastService.info('Sale cancelled');
      }
    } else {
      resetSaleForm();
    }
  };

  const formatCurrency = (amount) => {
    return `Rs. ${Math.abs(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  };

  const getSelectedCustomerName = () => {
    const customer = customers.find(c => c.id === saleData.customerId);
    return customer ? `${customer.name} (${customer.code || customer.id})` : 'No customer selected';
  };

  if (loading.customers || loading.routes || loading.products) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading sale interface...</p>
      </div>
    );
  }

  return (
    <div className="create-sale-container">
      {/* Header with polling indicator */}
      <div className="sale-header">
        <div className="header-top">
          <h1>Create Sale</h1>
          <div className="polling-indicator">
            <i className="fas fa-sync-alt"></i> Auto-refresh: 30s
          </div>
        </div>
        <div className="invoice-info">
          <span><i className="fas fa-file-invoice"></i> Invoice: {invoiceNumber}</span>
          <span><i className="fas fa-calendar"></i> Date: {new Date().toLocaleDateString()}</span>
          <span><i className="fas fa-user"></i> Customer: {getSelectedCustomerName()}</span>
        </div>
      </div>

      {/* Customer & Route Section */}
      <div className="sale-card">
        <h3>Customer & Route Details</h3>
        <div className="customer-row">
          <div className="form-group">
            <label htmlFor="customerSelect">Customer</label>
            <select 
              id="customerSelect"
              value={saleData.customerId}
              onChange={(e) => handleCustomerChange(e.target.value)}
              className="form-select"
            >
              <option value="">Select Customer</option>
              {customers.map(customer => (
                <option key={customer.id} value={customer.id}>
                  {customer.name} ({customer.code || customer.id})
                </option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="routeSelect">Route</label>
            <select 
              id="routeSelect"
              value={saleData.routeId}
              onChange={(e) => handleRouteChange(e.target.value)}
              className="form-select"
              disabled={!ShiftService.isShiftActive()}
            >
              <option value="">Select Route</option>
              {routes.map(route => (
                <option key={route.id} value={route.id}>
                  {route.name || `Route ${route.id}`}
                </option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="customer-info">
          <div className="info-item">
            <span>Customer Code:</span>
            <strong>
              {saleData.customerId ? 
                customers.find(c => c.id === saleData.customerId)?.code || 'N/A' : 
                'N/A'}
            </strong>
          </div>
          <div className="info-item">
            <span>Outstanding Balance:</span>
            <strong className={outstandingBalance > 0 ? 'balance-danger' : 'balance-safe'}>
              {formatCurrency(outstandingBalance)}
            </strong>
          </div>
        </div>
      </div>

      {/* Product Selection Section */}
      <div className="sale-card">
        <h3>Add Products</h3>
        <div className="product-selection-row">
          <div className="form-group">
            <label htmlFor="categorySelect">Category</label>
            <select 
              id="categorySelect"
              value={currentProduct.categoryId}
              onChange={(e) => handleCategoryChange(e.target.value)}
              className="form-select"
            >
              <option value="">All Categories</option>
              {categories.map(category => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="productSelect">Product</label>
            <select 
              id="productSelect"
              value={currentProduct.stockId || ''}
              onChange={(e) => handleProductChange(e.target.value)}
              className="form-select"
            >
              <option value="">Select Product</option>
              {filteredProducts.map(product => (
                <option 
                  key={product.id} 
                  value={product.id} 
                  disabled={product.availableStock <= 0}
                  className={product.availableStock <= 0 ? 'out-of-stock' : ''}
                >
                  {product.name} - {formatCurrency(product.price)} 
                  <span className={`stock-badge ${product.availableStock <= 5 ? 'low-stock' : 'in-stock'}`}>
                    (Stock: {product.availableStock})
                  </span>
                </option>
              ))}
            </select>
          </div>
        </div>
        
        {currentProduct.productId && (
          <div className="selected-product-info">
            <div className="info-row">
              <span>Selected:</span>
              <strong>{currentProduct.productName}</strong>
            </div>
            <div className="info-row">
              <span>Category:</span>
              <strong>{categories.find(c => c.id.toString() === currentProduct.categoryId.toString())?.name || 'N/A'}</strong>
            </div>
          </div>
        )}
        
        <div className="product-details-row">
          <div className="form-group">
            <label htmlFor="quantity">Quantity</label>
            <input 
              type="number" 
              id="quantity"
              value={currentProduct.quantity}
              onChange={(e) => handleQuantityChange(e.target.value)}
              min="1"
              max={currentProduct.availableStock}
              className="form-input"
              disabled={!currentProduct.productId}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="price">Unit Price (Rs.)</label>
            <input 
              type="number" 
              id="price"
              value={currentProduct.pricePerUnit}
              onChange={(e) => handlePriceChange(e.target.value)}
              min="0"
              step="0.01"
              className="form-input"
              disabled={!currentProduct.productId}
            />
          </div>
          
          <div className="form-group">
            <label>Available Stock</label>
            <div className={`stock-display ${currentProduct.availableStock <= 5 ? 'stock-low' : 'stock-ok'}`}>
              {currentProduct.availableStock}
            </div>
          </div>
          
          <button 
            onClick={addProductToCart}
            className="btn-add-product"
            disabled={!currentProduct.productId || currentProduct.quantity <= 0 || currentProduct.quantity > currentProduct.availableStock}
          >
            <i className="fas fa-cart-plus"></i> Add
          </button>
        </div>
      </div>

      {/* Return Section */}
      <div className="sale-card return-card">
        <h3><i className="fas fa-undo"></i> Process Return</h3>
        <div className="return-row">
          <div className="form-group">
            <label htmlFor="returnAmount">Return Amount (Rs.)</label>
            <input 
              type="number" 
              id="returnAmount"
              value={returnAmount}
              onChange={(e) => setReturnAmount(e.target.value)}
              min="0"
              step="0.01"
              className="form-input"
              placeholder="Enter return amount"
            />
          </div>
          <button 
            onClick={addReturnToCart}
            className="btn-add-return"
            disabled={!returnAmount || parseFloat(returnAmount) <= 0}
          >
            <i className="fas fa-minus-circle"></i> Add Return
          </button>
        </div>
      </div>

      {/* Cart Items */}
      <div className="sale-card cart-card">
        <h3><i className="fas fa-shopping-cart"></i> Cart Items ({cartItems.length})</h3>
        {cartItems.length === 0 ? (
          <div className="empty-cart">
            <i className="fas fa-cart-arrow-down"></i>
            <p>No items in cart</p>
          </div>
        ) : (
          <div className="cart-table-container">
            <table className="cart-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Total</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.map((item, index) => (
                  <tr key={index} className={item.type === 'return' ? 'return-item' : 'sale-item'}>
                    <td>
                      <div className="item-name">
                        {item.type === 'sale' ? item.name : 'Sale Return (Deduction)'}
                        {item.type === 'sale' && item.categoryName && (
                          <small className="category-tag"> {item.categoryName}</small>
                        )}
                      </div>
                    </td>
                    <td>{item.type === 'sale' ? item.quantity : '-'}</td>
                    <td>
                      {item.type === 'sale' ? formatCurrency(item.pricePerUnit) : '-'}
                    </td>
                    <td className={item.type === 'return' ? 'negative-amount' : 'positive-amount'}>
                      {item.type === 'sale' ? formatCurrency(item.total) : formatCurrency(item.amount)}
                    </td>
                    <td>
                      <button 
                        onClick={() => removeCartItem(index)}
                        className="btn-remove"
                        title="Remove item"
                      >
                        <div>X</div>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Summary Section */}
      {/* <div className="sale-card summary-card">
        <h3><i className="fas fa-calculator"></i> Invoice Summary</h3>
        <div className="summary-row">
          <span>Sub Total:</span>
          <span>{formatCurrency(totals.subTotal)}</span>
        </div>
        {totals.returns > 0 && (
          <div className="summary-row">
            <span>Returns:</span>
            <span className="negative-amount">-{formatCurrency(totals.returns)}</span>
          </div>
        )}
        <div className="summary-row grand-total">
          <span>NET TOTAL:</span>
          <span>{formatCurrency(totals.netTotal)}</span>
        </div>
        
        <div className="summary-row">
          <span>Paid Amount:</span>
          <span className="positive-amount">{formatCurrency(totals.paidAmount)}</span>
        </div>
        
        {totals.remainingBalance > 0 ? (
          <div className="summary-row balance-due">
            <span><i className="fas fa-exclamation-circle"></i> Balance Due:</span>
            <span className="negative-amount">{formatCurrency(totals.remainingBalance)}</span>
          </div>
        ) : totals.changeDue > 0 ? (
          <div className="summary-row change-due">
            <span><i className="fas fa-exchange-alt"></i> Change Due:</span>
            <span className="positive-amount">{formatCurrency(totals.changeDue)}</span>
          </div>
        ) : totals.netTotal > 0 ? (
          <div className="summary-row paid-exact">
            <span><i className="fas fa-check-circle"></i> Fully Paid</span>
            <span className="positive-amount">{formatCurrency(0)}</span>
          </div>
        ) : null}
      </div> */}
      <div className="sale-card summary-card">
  <h3><i className="fas fa-calculator"></i> Invoice Summary</h3>
  
  <div className="summary-container">
    <div className="summary-row">
      <span>Sub Total:</span>
      <span className="summary-amount">{formatCurrency(totals.subTotal)}</span>
    </div>
    
    {totals.returns > 0 && (
      <div className="summary-row">
        <span>Returns:</span>
        <span className="summary-amount negative-amount">-{formatCurrency(totals.returns)}</span>
      </div>
    )}
    
    <div className="summary-row grand-total">
      <span>NET TOTAL:</span>
      <span className="summary-amount">{formatCurrency(totals.netTotal)}</span>
    </div>
    
    <div className="summary-row">
      <span>Paid Amount:</span>
      <span className="summary-amount positive-amount">{formatCurrency(totals.paidAmount)}</span>
    </div>
    
    {totals.remainingBalance > 0 ? (
      <div className="summary-row balance-due">
        <span><i className="fas fa-exclamation-circle"></i> Balance Due:</span>
        <span className="summary-amount negative-amount">{formatCurrency(totals.remainingBalance)}</span>
      </div>
    ) : totals.changeDue > 0 ? (
      <div className="summary-row change-due">
        <span><i className="fas fa-exchange-alt"></i> Change Due:</span>
        <span className="summary-amount positive-amount">{formatCurrency(totals.changeDue)}</span>
      </div>
    ) : totals.netTotal > 0 ? (
      <div className="summary-row paid-exact">
        <span><i className="fas fa-check-circle"></i> Fully Paid</span>
        <span className="summary-amount positive-amount">{formatCurrency(0)}</span>
      </div>
    ) : null}
  </div>
</div>

      {/* Collection Section */}
      {outstandingBalance > 0 && (
        <div className="sale-card collection-card">
          <h3><i className="fas fa-hand-holding-usd"></i> Debt Collection</h3>
          <div className="collection-info">
            <div className="info-item">
              <span>Outstanding Debt:</span>
              <strong className="balance-danger">{formatCurrency(outstandingBalance)}</strong>
            </div>
            <div className="info-item">
              <span>Collected This Session:</span>
              <strong className="positive-amount">{formatCurrency(totals.collectedAmount)}</strong>
            </div>
            {totals.collectedAmount > 0 && (
              <div className="info-item">
                <span>New Balance:</span>
                <strong className={totals.newOutstandingBalance > 0 ? 'balance-danger' : 'balance-safe'}>
                  {formatCurrency(totals.newOutstandingBalance)}
                </strong>
              </div>
            )}
          </div>
          <button 
            onClick={openCollectionModal}
            className="btn-collection"
            disabled={processingSale}
          >
            <i className="fas fa-hand-holding-usd"></i> Record Debt Payment
          </button>
        </div>
      )}

      {/* Action Buttons */}
      <div className="action-buttons">
        <button 
          onClick={handleCancelSale}
          className="btn-cancel"
          disabled={processingSale}
        >
          <i className="fas fa-times"></i> {cartItems.length > 0 ? 'Cancel Sale' : 'Clear'}
        </button>
        
        <button 
          onClick={openPaymentModal}
          className="btn-payment"
          disabled={cartItems.length === 0 || processingSale}
        >
          <i className="fas fa-credit-card"></i> Take Payment
        </button>
        
        <button 
          onClick={handleCompleteSale}
          className="btn-complete"
          disabled={!totals.isFullyPaid || processingSale || cartItems.length === 0}
        >
          {processingSale ? (
            <>
              <i className="fas fa-spinner fa-spin"></i> Processing...
            </>
          ) : (
            <>
              <i className="fas fa-check"></i> Complete Sale
            </>
          )}
        </button>
      </div>

      {/* Payment Modal */}
      {showPaymentModal && (
        <div className="modal-overlay" onClick={() => setShowPaymentModal(false)}>
          <div className="modal-content payment-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3><i className="fas fa-credit-card"></i> Take Payment</h3>
              <button onClick={() => setShowPaymentModal(false)} className="btn-close">
                <i className="fas fa-times"></i>
              </button>
            </div>
            
            <div className="modal-body">
              <div className="payment-summary">
                <div className="summary-item">
                  <span>Net Total:</span>
                  <strong>{formatCurrency(totals.netTotal)}</strong>
                </div>
                <div className="summary-item">
                  <span>Paid So Far:</span>
                  <strong>{formatCurrency(totals.paidAmount)}</strong>
                </div>
                <div className="summary-item remaining-balance">
                  <span>Remaining Balance:</span>
                  <strong className={totals.remainingBalance > 0 ? 'negative-amount' : 'positive-amount'}>
                    {formatCurrency(Math.abs(totals.netTotal - totals.paidAmount))}
                  </strong>
                </div>
              </div>
              
              <div className="payment-input-row">
                <div className="form-group">
                  <label>Payment Method</label>
                  <select 
                    value={paymentInput.method}
                    onChange={(e) => setPaymentInput({...paymentInput, method: e.target.value})}
                    className="form-select"
                  >
                    <option value="CASH">Cash</option>
                    <option value="CHEQUE">Cheque</option>
                    <option value="BANK_TRANSFER">Bank Transfer</option>
                    <option value="CREDIT">Credit</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label>Amount (Rs.)</label>
                  <input 
                    type="number"
                    value={paymentInput.amount}
                    onChange={(e) => setPaymentInput({...paymentInput, amount: e.target.value})}
                    className="form-input"
                    placeholder="Enter amount"
                    step="0.01"
                    min="0"
                  />
                </div>
                
                <button onClick={addPayment} className="btn-add-payment">
                  <i className="fas fa-plus"></i> Add
                </button>
              </div>
              
              {/* Additional fields for cheque/bank transfer */}
              {paymentInput.method === 'CHEQUE' && (
                <div className="payment-details-row">
                  <div className="form-group">
                    <label>Cheque Number</label>
                    <input 
                      type="text"
                      value={paymentInput.chequeNumber}
                      onChange={(e) => setPaymentInput({...paymentInput, chequeNumber: e.target.value})}
                      className="form-input"
                      placeholder="Cheque number"
                    />
                  </div>
                  <div className="form-group">
                    <label>Bank Name</label>
                    <input 
                      type="text"
                      value={paymentInput.bank}
                      onChange={(e) => setPaymentInput({...paymentInput, bank: e.target.value})}
                      className="form-input"
                      placeholder="Bank name"
                    />
                  </div>
                </div>
              )}
              
              {paymentInput.method === 'BANK_TRANSFER' && (
                <div className="form-group">
                  <label>Reference Number</label>
                  <input 
                    type="text"
                    value={paymentInput.reference}
                    onChange={(e) => setPaymentInput({...paymentInput, reference: e.target.value})}
                    className="form-input"
                    placeholder="Reference number"
                  />
                </div>
              )}
              
              {/* Payment List */}
              <div className="payment-list">
                <h4><i className="fas fa-list"></i> Recorded Payments</h4>
                {tempPayments.length === 0 ? (
                  <p className="no-payments">No payments recorded</p>
                ) : (
                  <>
                    <table className="payments-table">
                      <thead>
                        <tr>
                          <th>Method</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tempPayments.map((payment, index) => (
                          <tr key={index}>
                            <td>
                              <span className={`payment-method ${payment.method.toLowerCase()}`}>
                                {payment.method}
                              </span>
                            </td>
                            <td>{formatCurrency(payment.amount)}</td>
                            <td>
                              <button 
                                onClick={() => removeTempPayment(index)}
                                className="btn-remove-small"
                                title="Remove payment"
                              >
                                <div>X</div>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="payment-total">
                      <span>Total:</span>
                      <strong>{formatCurrency(tempPayments.reduce((sum, p) => sum + p.amount, 0))}</strong>
                    </div>
                  </>
                )}
              </div>
            </div>
            
            <div className="modal-footer">
              <button 
                onClick={() => {
                  setTempPayments([]);
                  ToastService.info('Payments cleared');
                }}
                className="btn-secondary"
                disabled={tempPayments.length === 0}
              >
                <i className="fas fa-trash"></i> Clear All
              </button>
              <button onClick={confirmPayments} className="btn-primary">
                <i className="fas fa-check"></i> Confirm Payments
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Collection Modal */}
      {showCollectionModal && (
        <div className="modal-overlay" onClick={() => setShowCollectionModal(false)}>
          <div className="modal-content collection-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3><i className="fas fa-hand-holding-usd"></i> Record Debt Collection</h3>
              <button onClick={() => setShowCollectionModal(false)} className="btn-close">
                <i className="fas fa-times"></i>
              </button>
            </div>
            
            <div className="modal-body">
              <div className="collection-summary">
                <div className="summary-item">
                  <span>Outstanding Balance:</span>
                  <strong className="balance-danger">{formatCurrency(outstandingBalance)}</strong>
                </div>
                <div className="summary-item">
                  <span>Collected This Session:</span>
                  <strong className="positive-amount">
                    {formatCurrency(tempCollections.reduce((sum, col) => sum + col.amount, 0))}
                  </strong>
                </div>
                <div className="summary-item">
                  <span>Remaining After Collection:</span>
                  <strong className="balance-danger">
                    {formatCurrency(outstandingBalance - tempCollections.reduce((sum, col) => sum + col.amount, 0))}
                  </strong>
                </div>
              </div>
              
              <div className="collection-input-row">
                <div className="form-group">
                  <label>Payment Method</label>
                  <select 
                    value={collectionInput.method}
                    onChange={(e) => setCollectionInput({...collectionInput, method: e.target.value})}
                    className="form-select"
                  >
                    <option value="CASH">Cash</option>
                    <option value="CHEQUE">Cheque</option>
                    <option value="BANK_TRANSFER">Bank Transfer</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label>Amount to Collect (Rs.)</label>
                  <input 
                    type="number"
                    value={collectionInput.amount}
                    onChange={(e) => setCollectionInput({...collectionInput, amount: e.target.value})}
                    className="form-input"
                    placeholder="Enter amount"
                    step="0.01"
                    min="0"
                  />
                </div>
                
                <button onClick={addCollectionPayment} className="btn-add-collection">
                  <i className="fas fa-plus"></i> Add
                </button>
              </div>
              
              {/* Additional fields for cheque/bank transfer */}
              {collectionInput.method === 'CHEQUE' && (
                <div className="collection-details-row">
                  <div className="form-group">
                    <label>Cheque Number</label>
                    <input 
                      type="text"
                      value={collectionInput.chequeNumber}
                      onChange={(e) => setCollectionInput({...collectionInput, chequeNumber: e.target.value})}
                      className="form-input"
                      placeholder="Cheque number"
                    />
                  </div>
                  <div className="form-group">
                    <label>Bank Name</label>
                    <input 
                      type="text"
                      value={collectionInput.bank}
                      onChange={(e) => setCollectionInput({...collectionInput, bank: e.target.value})}
                      className="form-input"
                      placeholder="Bank name"
                    />
                  </div>
                </div>
              )}
              
              {collectionInput.method === 'BANK_TRANSFER' && (
                <div className="form-group">
                  <label>Reference Number</label>
                  <input 
                    type="text"
                    value={collectionInput.reference}
                    onChange={(e) => setCollectionInput({...collectionInput, reference: e.target.value})}
                    className="form-input"
                    placeholder="Reference number"
                  />
                </div>
              )}
              
              {/* Collection List */}
              <div className="collection-list">
                <h4><i className="fas fa-list"></i> Recorded Collections</h4>
                {tempCollections.length === 0 ? (
                  <p className="no-collections">No collections recorded</p>
                ) : (
                  <>
                    <table className="collections-table">
                      <thead>
                        <tr>
                          <th>Method</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tempCollections.map((collection, index) => (
                          <tr key={index}>
                            <td>
                              <span className={`collection-method ${collection.method.toLowerCase()}`}>
                                {collection.method}
                              </span>
                            </td>
                            <td>{formatCurrency(collection.amount)}</td>
                            <td>
                              <button 
                                onClick={() => removeTempCollection(index)}
                                className="btn-remove-small"
                                title="Remove collection"
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="collection-total">
                      <span>Total Collected:</span>
                      <strong>{formatCurrency(tempCollections.reduce((sum, col) => sum + col.amount, 0))}</strong>
                    </div>
                  </>
                )}
              </div>
            </div>
            
            <div className="modal-footer">
              <button 
                onClick={() => {
                  setTempCollections([]);
                  ToastService.info('Collections cleared');
                }}
                className="btn-secondary"
                disabled={tempCollections.length === 0}
              >
                <i className="fas fa-trash"></i> Clear All
              </button>
              <button onClick={confirmCollections} className="btn-collection">
                <i className="fas fa-check"></i> Confirm Collections
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateSale;
